import React, { useEffect, useState } from "react";
import WorkIcon from "@mui/icons-material/Work";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BadgeIcon from "@mui/icons-material/Badge";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CategoryIcon from "@mui/icons-material/Category";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import { Tooltip } from "@mui/material";
import { FiX } from "react-icons/fi";
// import CreateIcon from '@mui/icons-material/Create';
import EditAttributesIcon from "@mui/icons-material/EditAttributes";
import { Typography, Paper, ClickAwayListener } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import PublicIcon from "@mui/icons-material/Public";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { IoTime } from "react-icons/io5";
import { IoDocumentText } from "react-icons/io5";
import { IoArrowBack } from "react-icons/io5";
import BusinessIcon from "@mui/icons-material/Business";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import { Plus } from "lucide-react";
import { IoPrintOutline } from "react-icons/io5";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PaymentsIcon from "@mui/icons-material/Payments";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { IoSaveOutline } from "react-icons/io5";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RoomIcon from "@mui/icons-material/Room";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  AssignmentInd as PassportIcon,
  Event as EventIcon,
  LocationCity as PlaceIcon,
  Public as CountryIcon,
  InsertDriveFile as ImageIcon,
} from "@mui/icons-material";
import {
  Card,
  CardContent,
  FormHelperText,
  InputAdornment,
  IconButton,
  FormLabel,
  Input,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { FormGroup, FormControlLabel, Switch, div } from "@mui/material";
import dayjs from "dayjs";

import { IoIosPerson } from "react-icons/io";
import { GiOfficeChair } from "react-icons/gi";
import { MdContactEmergency, MdMenuOpen } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import { MdAddChart } from "react-icons/md";

import { MdFormatListBulletedAdd } from "react-icons/md";
// import MasterJobTablePopUp from "./MasterJobTablePopUp";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { GetAlv, GetInc, getAllEmp } from "../../../features/Emp/EmpSlice";
import { TbEPassport } from "react-icons/tb";
import { IoIosContact } from "react-icons/io";
import { IoDocumentsOutline } from "react-icons/io5";
import { GiThreeLeaves } from "react-icons/gi";
import { MdAddCircleOutline } from "react-icons/md";
import CreateIncrementPopup from "../ViewEmp/CreateIncrementPopup";
import axios from "axios";
import SalaryPayablePopup from "../Emp/SalaryPayablePopup";
import { base_url } from "../../../utils/AxiosConfig";
import CreateAllowance from "../CreateAllowance/CreateAllowance";
import CreateIncrement from "../CreateIncrement/CreateIncrement";
import MasterJobTablePopUp from "../Emp/MasterJobTablePopUp";
import { Oval } from "react-loader-spinner";
import { Button } from "@mui/material";
import { base_url_image_view_api } from "../../../utils/ImageViewingAPI";
import { base_url_image_post_api } from "../../../utils/ImageCreationAPI";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { Badge } from "@mui/icons-material";
import user2 from "../../../images/ic_no_person_photo.svg";
import docPhoto from "../../../images/doc-icon2.svg";
// import docPhoto from "../../../images/doc-icon.svg";
import user1 from "../../../images/userLayer.png";
import ic_dropdown from "../../images/ic_dropdown.png";
import ic_pencil from "../../images/ic_pencil.png";
import ic_close_department from "../../images/ic_close_department.png";
import {
  AccountCircle,
  // Badge,
  Wc,
  CalendarToday,
  Height as HeightIcon,
  MonitorWeight,
  Favorite,
  GroupWork,
  Language,
  VpnKey,
  AlternateEmail,
  Work,
  Visibility,
  CheckCircle,
  Accessibility,
  Home as HomeIcon,
  FlightTakeoff as FlightTakeoffIcon,
  LocationOn as LocationOnIcon,
  PhoneIphone as PhoneIphoneIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
} from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import VisaIcon from "@mui/icons-material/AssignmentInd"; // Substitute for visa
import PersonIcon from "@mui/icons-material/Person";
import EngineeringIcon from "@mui/icons-material/Engineering";

import { Box } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import SnackbarNotification from "../../../utils/SnackbarNotification";

const inputBaseClass =
  "min-h-[42px] w-full rounded-lg border bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-500";

const inputStateClass =
  "border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20";

const inputErrorClass =
  "border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-500/20";

const TailwindTextField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  disabled = false,
  readOnly = false,
  type = "text",
  placeholder,
  className = "",
  fullWidth,
  InputProps = {},
  inputProps = {},
  InputLabelProps,
  error,
  helperText,
  multiline = false,
  rows = 3,
  id,
  ...rest
}) => {
  void InputLabelProps;
  void rest;

  const fieldId = id || name;
  const isReadOnly = readOnly || Boolean(InputProps?.readOnly);
  const startAdornment = InputProps?.startAdornment;
  const endAdornment = InputProps?.endAdornment;
  const FieldTag = multiline ? "textarea" : "input";
  const fieldType = multiline ? undefined : type;

  const field = (
    <FieldTag
      id={fieldId}
      name={name}
      type={fieldType}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      readOnly={isReadOnly}
      placeholder={placeholder}
      rows={multiline ? rows : undefined}
      className={[
        inputBaseClass,
        error ? inputErrorClass : inputStateClass,
        startAdornment ? "pl-2" : "",
        endAdornment ? "pr-2" : "",
        multiline ? "min-h-[96px] resize-y" : "",
        InputProps?.className || "",
        inputProps?.className || "",
      ]
        .filter(Boolean)
        .join(" ")}
      {...inputProps}
    />
  );

  return (
    <div className={["w-full", className].filter(Boolean).join(" ")}>
      {label && (
        <label
          htmlFor={fieldId}
          className="mb-1 block text-xs font-medium text-slate-600"
        >
          {label}
        </label>
      )}

      {startAdornment || endAdornment ? (
        <div
          className={[
            "flex min-h-[42px] items-center rounded-lg border bg-white transition focus-within:ring-2 disabled:bg-slate-100",
            error
              ? "border-red-400 focus-within:border-red-500 focus-within:ring-red-500/20"
              : "border-slate-300 focus-within:border-blue-500 focus-within:ring-blue-500/20",
            disabled ? "bg-slate-100" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {startAdornment && (
            <span className="flex shrink-0 items-center pl-3 text-slate-500">
              {startAdornment}
            </span>
          )}
          <FieldTag
            id={fieldId}
            name={name}
            type={fieldType}
            value={value ?? ""}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            readOnly={isReadOnly}
            placeholder={placeholder}
            rows={multiline ? rows : undefined}
            className={[
              "min-h-[40px] min-w-0 flex-1 border-0 bg-transparent px-3 py-2 text-sm text-slate-900 outline-none placeholder:text-slate-400 disabled:cursor-not-allowed disabled:text-slate-500",
              multiline ? "min-h-[96px] resize-y" : "",
              inputProps?.className || "",
            ]
              .filter(Boolean)
              .join(" ")}
            {...inputProps}
          />
          {endAdornment && (
            <span className="flex shrink-0 items-center pr-2 text-slate-500">
              {endAdornment}
            </span>
          )}
        </div>
      ) : (
        field
      )}

      {helperText && (
        <p
          className={[
            "mt-1 text-xs",
            error ? "text-red-600" : "text-slate-500",
          ].join(" ")}
        >
          {helperText}
        </p>
      )}
    </div>
  );
};

// Inside your component JSX:
let Empschema = Yup.object().shape({
  CmpCode: Yup.string(),
  EmpId: Yup.string(),
  AlternateID: Yup.string(),
  Status: Yup.string(),
  Title: Yup.string(),
  FistName: Yup.string(),
  MiddleName: Yup.string(),
  LastName: Yup.string(),
  DOB: Yup.string(),
  MaritalStatus: Yup.string(),
  Gender: Yup.string(),
  Nationality: Yup.string(),
  Height: Yup.string(),
  Weight: Yup.string(),
  JoinDate: Yup.string(),
  JobTitle: Yup.string(),
  JobType: Yup.string(),
  ShiftGroup: Yup.string(),
  Department: Yup.string(),
  Division: Yup.string(),
  Grade: Yup.string(),
  BankAccountNo: Yup.string(),
  BankName: Yup.string(),
  AgentID: Yup.string(),
  CurrentAddress: Yup.string(),
  HomeAddress: Yup.string(),
  HomeAirport: Yup.string(),
  WorkMobile: Yup.string(),
  PersonalMobile: Yup.string(),
  WorkPhone: Yup.string(),
  PersonalPhone: Yup.string(),
  WorkEmail: Yup.string(),
  PersonalEmail: Yup.string(),
  PassportNo: Yup.string(),
  PassportIssueDate: Yup.string(),
  PassportExpiryDate: Yup.string(),
  PassportPlaceofIssue: Yup.string(),
  PassportCountryofIssue: Yup.string(),
  EmiratesId: Yup.string(),
  EmiratesIdExpiryDate: Yup.string(),
  VisaNo: Yup.string(),
  VisaExpiryDate: Yup.string(),
  InsuranceNo: Yup.string(),
  InsuranceExpiryDate: Yup.string(),
  DrivingLicenceNo: Yup.string(),
  DrivingLicenceExpiryDate: Yup.string(),
  PersonId: Yup.string(),
  PersonIdExpiryDate: Yup.string(),
  BasicPay: Yup.string(),
  Allowances_OT: Yup.string(),
  Allowances_NOT: Yup.string(),
  NetSalary: Yup.string(),
  NormalHrs: Yup.string(),
  HourlyWage: Yup.string(),
  OTrate: Yup.string(),
  SplOtRate: Yup.string(),
  photo: Yup.string(),
  Active: Yup.string(),
  Memos: Yup.string(),
  Notes: Yup.string(),
  SalaryAc: Yup.string(),
  AdvanceAc: Yup.string(),
  password: Yup.string(),
  onlineallow: Yup.string(),
});
const EditForm = ({ getEmpid }) => {
  dayjs.extend(customParseFormat);

  const initialBranchInAction = {
    branch_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  const initialDepartmentInAction = {
    dept_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  const initialGradeInAction = {
    grade_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  // ShiftGroup
  const initialShiftGroupInAction = {
    shiftGroup_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7377", // dummy transaction id
    mode: "ENTRY",
  };

  const [branchNameInInputBoxNew, setBranchNameInInputBoxNew] = useState(
    initialBranchInAction,
  );
  const [departmentNameInInputBoxNew, setDepartmentNameInInputBoxNew] =
    useState(initialDepartmentInAction);
  const [gradeNameInInputBoxNew, setGradeNameInInputBoxNew] =
    useState(initialGradeInAction);
  // ShiftGroup
  const [shiftGroupNameInInputBoxNew, setShiftGroupNameInInputBoxNew] =
    useState(initialShiftGroupInAction);

  const [leaveHistoryData, setLeaveHistoryData] = useState();
  const [leaveStatusData, setLeaveStatusData] = useState();
  const [allowanceDataFromChild, setAllowanceDataFromChild] = useState(null);
  const [incrementsDataFromChild, setIncrementsDataFromChild] = useState(null);
  const [AllowanceData, setAllowanceData] = useState(null);
  const [IncrementData, setIncrementData] = useState(null);
  const [allowanceAmountSum, setAllowanceAmountSum] = useState(0);
  const [incrementAmountSum, setIncrementAmountSum] = useState(0);
  const initialBranchInActionEdit = {
    branch_name: "",
    transaction_id: "",
    mode: "EDIT",
  };
  const initialDepartmentInActionEdit = {
    dept_name: "",
    transaction_id: "",
    mode: "EDIT",
  };
  const initialGradeInActionEdit = {
    grade_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // shift group
  const initialShiftGroupInActionEdit = {
    shiftGroup_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  const [branchNameInInputBoxEdit, setBranchNameInInputBoxEdit] = useState(
    initialBranchInActionEdit,
  );
  const [departmentNameInInputBoxEdit, setDepartmentNameInInputBoxEdit] =
    useState(initialDepartmentInActionEdit);
  const [gradeNameInInputBoxEdit, setGradeNameInInputBoxEdit] = useState(
    initialGradeInActionEdit,
  );

  // ShiftGroup
  const [shiftGroupNameInInputBoxEdit, setShiftGroupNameInInputBoxEdit] =
    useState(initialShiftGroupInActionEdit);
  const [showBranchCreationEditPopup, setShowBranchCreationEditPopup] =
    useState(false);
  const [showDepartmentCreationEditPopup, setShowDepartmentCreationEditPopup] =
    useState(false);
  const [showGradeCreationEditPopup, setShowGradeCreationEditPopup] =
    useState(false);

  // ShiftGroup
  const [showShiftGroupCreationEditPopup, setShowShiftGroupCreationEditPopup] =
    useState(false);

  const [showDepartmentList, setShowDepartmentList] = useState(false);

  const [departmentLisFromAPI, setDepartmentLisFromAPI] = useState(null);
  const [deptLisFromAPI, setDeptLisFromAPI] = useState(null);

  let portNumberLocal = localStorage.getItem("BondTimeportNoData");

  let portNumber = JSON.parse(portNumberLocal)[0].PORTNO;

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const dispatch = useDispatch();

  // const [empEditPostData, setEmpEditPostData] = useState();
  const [showSubmitLoader, setShowSubmitLoader] = useState(false);

  const [basicPay, setbasicPay] = useState(null);
  const [IncTotal, setIncTotal] = useState(null);
  const [AlvTotal, setAlvTotal] = useState(null);
  const [Category, setCategory] = useState(true);
  const [empState, setempState] = useState();

  const [isPayrollExpanded, setIsPayrollExpanded] = useState(false);
  const [isPayrollLoading, setIsPayrollLoading] = useState(false);
  // const empState = useSelector((state) => state?.emp?.emplist);

  const [SalaryPayment, setSalaryPay] = useState();
  const empStateAlv = useSelector((state) => state?.emp.GetAlv);
  const empStateInc = useSelector((state) => state?.emp.GetInc);
  const empStatelist = useSelector((state) => state?.emp?.emplist);

  const [userDataArray, setUserDataArray] = useState([]);

  const [loginUser, setLoginUser] = useState("");

  const [imagePath, setImagePath] = useState("");

  const [imageDescription, setImageDescription] = useState("EMPIMAGE");

  const [photo, setPhoto] = useState(null);

  const [photoFile, setPhototFile] = useState(null);

  const [photoUrl, setPhotoUrl] = useState(null);

  const [userDoc, setUserDoc] = useState(null);

  const [docPath, setDocPath] = useState("");

  const [userDocHistory, setUserDocHistory] = useState("");

  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [statusListFromAPI, setStatusListFromAPI] = useState(null);

  const handlePhotoUpload = (event) => {
    // console.log("handlePhotoUpload:");
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setPhoto(URL.createObjectURL(file)); // Create a preview URL
      setPhototFile(file);
      setImagePath(file);
      console.log("File uploaded:", file);
    } else {
      alert("Please upload a valid image file!");
    }
  };

  const handleDocumentUpload = (event) => {
    const file = event.target.files[0]; // Get the first file from the input
    if (file) {
      setUserDoc(file); // Update the state with the selected file
    }
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
  };

  const getDefaultDateTime = () => {
    const now = new Date();
    now.setHours(8, 0, 0, 0); // 8:00 AM
    return now.toISOString().slice(0, 16); // format: YYYY-MM-DDTHH:mm
  };

  const formatDateTimeSQL = (value) => {
    const date = new Date(value);

    const pad = (n) => n.toString().padStart(2, "0");

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate(),
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds(),
    )}`;
  };

  // Save Edit Employee Data from here!

  // const postEmpData = async () => {
  //   setShowSubmitLoader(true);
  //   try {
  //     const EmpRes = await axios.post(
  //       `${base_url}/api/PersonalInfoReg/`,
  //       empEditPostData,
  //     );

  //     if (EmpRes.data.result === "Saved") {
  //       // toast.success("Edited Employee Successfully");
  //       createAllowance(allowanceDataFromChild);
  //       createIncrement(incrementsDataFromChild);
  //       showSnackbar("success", "Edited Employee Successfully");
  //       setEmpEditPostData();
  //       setShowSubmitLoader(false);
  //       navigateToList();
  //     } else {
  //       // toast.error("Something went wrong");
  //       showSnackbar("error", "Something went wrong");

  //       setShowSubmitLoader(false);
  //     }
  //   } catch (error) {
  //     // toast.error("An error occurred while submitting the form");
  //     showSnackbar("error", "An error occurred while submitting the form");
  //     setShowSubmitLoader(false);

  //     console.error("Submission error:", error);
  //   }
  // };

  const handleSubmit = async (values) => {
    if (showSubmitLoader) return;

    const payload = [
      {
        ...values,
        regularTime: formatDateTimeSQL(values.regularTime),
      },
    ];

    setShowSubmitLoader(true);

    try {
      const EmpRes = await axios.post(
        `${base_url}/api/PersonalInfoReg/`,
        payload,
      );

      if (EmpRes.data.result === "Saved") {
        await Promise.all([
          allowanceDataFromChild
            ? createAllowance(allowanceDataFromChild)
            : Promise.resolve(),
          incrementsDataFromChild
            ? createIncrement(incrementsDataFromChild)
            : Promise.resolve(),
        ]);

        showSnackbar("success", "Edited Employee Successfully");
        navigateToList();
      } else {
        showSnackbar("error", "Something went wrong");
      }
    } catch (error) {
      console.error("Submission error:", error);
      showSnackbar("error", "An error occurred while submitting the form");
    } finally {
      setShowSubmitLoader(false);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      mode: "EDIT",
      EmpId: empState?.EmpId || "",
      AlternateID: empState?.AlternateID || "",
      Status: empState?.Status || "",
      Title: empState?.Title || "",
      FistName: empState?.FistName || "",
      MiddleName: empState?.MiddleName || "",
      LastName: empState?.LastName || "",
      DOB: empState?.DOB || "",
      MaritalStatus: empState?.MaritalStatus || "",
      Gender: empState?.Gender || "",
      Nationality: empState?.Nationality || "",
      Height: empState?.Height || "",
      Weight: empState?.Weight || "",
      JoinDate: empState?.JoinDate || "",
      JobTitle: empState?.JobTitle || "",
      JobType: empState?.JobType || "",
      ShiftGroup: empState?.ShiftGroup || "",
      Department: empState?.Department || "",
      Division: empState?.Division || "",
      Grade: empState?.Grade || "",
      BankAccountNo: empState?.BankAccountNo || "",
      BankName: empState?.BankName || "",
      AgentID: empState?.AgentID || "",
      CurrentAddress: empState?.CurrentAddress || "",
      HomeAddress: empState?.HomeAddress || "",
      HomeAirport: empState?.HomeAirport || "",
      WorkMobile: empState?.WorkMobile || "",
      PersonalMobile: empState?.PersonalMobile || "",
      WorkPhone: empState?.WorkPhone || "",
      PersonalPhone: empState?.PersonalPhone || "",
      WorkEmail: empState?.WorkEmail || "",
      PersonalEmail: empState?.PersonalEmail || "",
      PassportNo: empState?.PassportNo || "",
      PassportIssueDate: empState?.PassportIssueDate || "",
      PassportExpiryDate: empState?.PassportExpiryDate || "",
      PassportPlaceofIssue: empState?.PassportPlaceofIssue || "",
      PassportCountryofIssue: empState?.PassportCountryofIssue || "",
      EmiratesId: empState?.EmiratesId || "",
      EmiratesIdExpiryDate: empState?.EmiratesIdExpiryDate || "",
      VisaNo: empState?.VisaNo || "",
      VisaExpiryDate: empState?.VisaExpiryDate || "",
      InsuranceNo: empState?.InsuranceNo || "",
      InsuranceExpiryDate: empState?.InsuranceExpiryDate || "",
      DrivingLicenceNo: empState?.DrivingLicenceNo || "",
      DrivingLicenceExpiryDate: empState?.DrivingLicenceExpiryDate || "",
      PersonId: empState?.PersonId || "",
      PersonIdExpiryDate: empState?.PersonIdExpiryDate || "",
      BasicPay: basicPay ? basicPay : empState?.BasicPay || 0,
      Allowances_OT: AlvTotal || 0,
      Allowances_NOT: IncTotal || 0,
      NetSalary:
        basicPay + IncTotal + AlvTotal
          ? basicPay + IncTotal + AlvTotal
          : empState?.NetSalary || 0,
      NormalHrs: empState?.NormalHrs || 0,
      HourlyWage: empState?.HourlyWage || 0,
      OTrate: empState?.OTrate || 0,
      SplOtRate: empState?.SplOtRate || 0,
      // photo: photo ? photo : "",
      photo: "",
      Active: empState?.Active || "",
      Memos: empState?.Memos || "",
      Notes: empState?.Notes || "",
      SalaryAc: empState?.SalaryAc || "",
      AdvanceAc: empState?.AdvanceAc || "",
      password: empState?.password || "",
      onlineallow: empState?.onlineallow || "",
      Latitude: empState?.Latitude || "",
      Longitude: empState?.longitude || "",
      // PartTimeLabour: empState?.PartTimeLabour || "",
      PartTimeLabour: empState?.parttime || null,
      // PartTimeLabourExpiryDate: empState?.PartTimeLabourExpiryDate || "",
      PartTimeLabourExpiryDate: empState?.parttimeexp || null,
      regularTime: empState?.regulartime ?? getDefaultDateTime(),
    },
    validationSchema: Empschema,
    // onSubmit: (values) => {
    //   const valuesWithFormattedRegularTime = {
    //     ...values,
    //     regularTime: formatDateTimeSQL(formik.values.regularTime),
    //   };
    //   setEmpEditPostData([valuesWithFormattedRegularTime]);
    // },
    onSubmit: handleSubmit,
  });

  const createAllowance = async (values) => {
    try {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoAllowanceReg`,
        values,
      );

      if (response.data) {
        // Show success snackbar
        setOpenSnackbar(true);
        // if (getAllowanceList) {
        //   getAllowanceList(empState?.EmpId);
        // }
        return response.data;
      }
    } catch (error) {
      console.error("Error creating allowance:", error);
      setErrorMessage(
        error.response?.data?.message || "Failed to create allowance",
      );
      setOpenErrorSnackbar(true);
    }
  };

  const createIncrement = async (values) => {
    try {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoIncrementReg`,
        values,
      );

      if (response.data) {
        // Show success snackbar
        setOpenSnackbar(true);

        return response.data;
      }
    } catch (error) {
      console.error("Error creating increment:", error);
      setErrorMessage(
        error.response?.data?.message || "Failed to create increment",
      );
      setOpenErrorSnackbar(true);
    }
  };

  // useEffect(() => {
  //   if (empEditPostData) {
  //     postEmpData();

  //     // sendUserImage();
  //   }
  // }, [empEditPostData]);

  const calculationInc = (Incsum) => {
    // the callback. Use a better name
    // console.log(Incsum);
    setIncTotal(Incsum);
  };
  const calculationAlv = (Alvsum) => {
    // the callback. Use a better name
    // console.log(Alvsum);
    setAlvTotal(Alvsum);
  };

  // useEffect(() => {
  //   const getData = async () => {
  //     const response = await axios.get(
  //       `${base_url}/api/PersonalInfoList/${companyCode}/SINGLE/YES/${getEmpid}/ALL/ALL/ALL`,
  //     );
  //     if (response?.data) {
  //       setempState(response.data[0]);
  //       LeaveHistory(getEmpid);
  //       LeaveStatus(getEmpid);
  //     } else {
  //       console.log("error");
  //     }
  //   };

  //   getData();
  // }, [getEmpid]);

  const empId = empState?.EmpId;

  useEffect(() => {
    if (!getEmpid || !companyCode) return;

    let cancelled = false;

    const loadEmployee = async () => {
      try {
        const { data } = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/SINGLE/YES/${getEmpid}/ALL/ALL/ALL`,
        );

        if (cancelled) return;

        const employee = data?.[0];
        setempState(employee);

        await Promise.all([
          axios
            .get(
              `${base_url}/api/CpaysCount/${companyCode}/LEAVE_HISTORY/${getEmpid}/-`,
            )
            .then((res) => !cancelled && setLeaveHistoryData(res.data)),
          axios
            .get(
              `${base_url}/api/CpaysCount/${companyCode}/LEAVE_STATUS/${getEmpid}/-`,
            )
            .then((res) => !cancelled && setLeaveStatusData(res.data)),
        ]);
      } catch (error) {
        console.error("Failed to load employee:", error);
      }
    };

    loadEmployee();

    return () => {
      cancelled = true;
    };
  }, [getEmpid, companyCode]);

  // const LeaveHistory = async (getEmpid) => {
  //   try {
  //     const response = await axios.get(
  //       // `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVEHISTORY/${getEmpid}/1900-01-01/1900-01-01/-`,
  //       // }/${FromDate}/${ToDate}/-`
  //       `${base_url}/api/CpaysCount/${companyCode}/LEAVE_HISTORY/${getEmpid}/-`,
  //     );
  //     if (response?.data) {
  //       // console.log("response.data leave history", response.data);
  //       setLeaveHistoryData(response.data);
  //     } else {
  //       console.log("error");
  //     }
  //   } catch (err) {
  //     console.error("Error while fetchinh leave history:", err);
  //   }
  // };

  // const LeaveStatus = async (getEmpid) => {
  //   const response = await axios.get(
  //     // `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVESTATUS/${getEmpid}/1900-01-01/1900-01-01/-`,
  //     // `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVESTATUS/${PopUpData?.EmpId?PopUpData?.EmpId:null}/${FromDate}/${ToDate}/-`
  //     `${base_url}/api/CpaysCount/${companyCode}/LEAVE_STATUS/${getEmpid}/-`,
  //   );
  //   if (response?.data) {
  //     setLeaveStatusData(response.data);
  //     console.log("leave status:", response.data);
  //   } else {
  //     console.log("error");
  //   }
  // };

  const getStatusList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/STATUS/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setStatusListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    if (!empState?.EmpId) return;

    dispatch(GetAlv(empState.EmpId));
    dispatch(GetInc(empState.EmpId));
  }, [dispatch, empState?.EmpId]);

  const getData = async () => {
    console.log("edited dispatch ");
    dispatch(getAllEmp());
  };

  const getDepartmentList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDepartmentLisFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getDeptList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPT/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDeptLisFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    // getData();
    getDepartmentList();
    getDeptList();
    getGradeList();
    getJobTitleList();
    getDivisionList();
    getShiftGroupList();
    getStatusList();
  }, []);

  useEffect(() => {
    let Incsum = empStateInc?.reduce((a, v) => (a = a + v.Amount), 0);

    setIncTotal(Incsum);
  }, [empStateInc]);

  useEffect(() => {
    let AlvSum = empStateAlv?.reduce((a, v) => (a = a + v.Amount), 0);

    setAlvTotal(AlvSum);
  }, [empStateAlv]);

  function handleAddrTypeChange(e) {
    setCategory(e.target.value);
    console.log(Category);
  }
  const SalaryPayable = (SalaryPay) => {
    // the callback. Use a better name
    console.log(SalaryPay);
    setSalaryPay(SalaryPay);
  };

  const fetchImagePath = async () => {
    let apiUrlImage = `${base_url}/api/MasterCount/${companyCode}/IMAGEPATH/${loginUser}/EMPIMAGE`;
    console.log("apiUrlImage ", apiUrlImage);
    try {
      const response = await axios.get(apiUrlImage);
      console.log("image path response", response);
      if (response.status === 200) {
        console.log("fetchPath response:::", response.data);
        setImagePath(response.data);
      }
    } catch (error) {
      console.log("fetchImagePathErr", error);
    }
  };

  const fetchDocPath = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/MasterCount/${companyCode}/IMAGEPATH/${loginUser}/DOCIMAGE`,
      );

      if (response.status === 200) {
        console.log("fetchDocPath response:::", response.data);
        setDocPath(response.data);
      }
    } catch (error) {
      console.log("fetchDocPathErr", error);
    }
  };

  const sendUserDoc = async () => {
    if (!userDoc) {
      // toast.warn("no document selected");
      showSnackbar("warning", "No document selected");

      return;
    }
    console.log("userDoc::", userDoc);
    console.log("docPath::", docPath);

    try {
      // Create a FormData instance
      const formData = new FormData();
      formData.append("DOC_CODE", formik.values.EmpId);
      formData.append("DOC_TYPE", "DOCIMAGE");
      formData.append("file", userDoc);
      formData.append("cmpcode", companyCode);
      // formData.append("IMGBASE64", "XX");
      formData.append("IMGBASE64", "-");
      // formData.append("IMAGEPATH", docPath[0].imagepath);

      let postEmpImagePath = localStorage.getItem("PostEmpImagePath");
      console.log("postEmpImagePath:", postEmpImagePath);
      console.log("postEmpImagePath:", `${postEmpImagePath}BONDTIME_EMP_IMG\\`);

      // Step 1: Clean up postEmpImagePath by removing extra quotes and trimming spaces
      let basePath = postEmpImagePath.replace(/['"]+/g, "").trim();

      // Step 2: Ensure it ends with a single backslash
      if (!basePath.endsWith("\\")) {
        basePath += "\\";
      }

      // Step 3: Append subfolder
      // const fullPath = `c:\\fileupload_common\\BONDTIME_EMP_IMG\\`;
      const fullPath = `${basePath}BONDTIME_DOC_IMG\\`;

      // Step 4: Add to formData
      formData.append("IMAGEPATH", fullPath);

      // Debug
      console.log("fullPath:", fullPath);

      // Axios configuration
      // const config = {
      //   headers: {
      //     "Content-Type": "multipart/form-data", // Ensure the correct content type
      //   },
      // };

      console.log("formData", formData);

      // Send the POST request
      const response = await axios.post(
        `${base_url_image_post_api}/api/Image/upload`,
        formData,
      );

      // Handle response
      console.log("Response1:", response);
      console.log("Response2:", response.data);

      if (response.status === 200) {
        // toast.success("Doc uploaded successfully");
        showSnackbar("success", "Doc uploaded successfully");
        fetchDocData(empState?.EmpId);
        // setUserDoc("");
        setUserDoc(null);
      }
      // return response.data;
    } catch (error) {
      // Handle error
      // console.error("Error uploading data:", error.response || error.message);
      console.error("Error uploading data:", error);
      showSnackbar("error", "Some error occurred");

      // toast.error("Some error occured");
      // throw error;
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const sendUserImage = async () => {
    if (!photo && !photoFile && !photoUrl) {
      // toast.warn("no picture selected");
      showSnackbar("warning", "No picture selected");

      return;
    }

    console.log("imagePath", imagePath);
    console.log("photoFile", photoFile);
    try {
      // Create a FormData instance
      const formData = new FormData();
      // formData.append('UserId', formik.values.EmpId);
      // formData.append('Description', imageDescription || '');
      // formData.append('Image', photoFile); // Assuming `imageFile` is a File or Blob
      // formData.append('ImagePath', imagePath[0]?.imagepath)

      let resultOfBAse64Conversion = await toBase64(photoFile);

      // formData.append("IMGBASE64", resultOfBAse64Conversion);
      formData.append("IMGBASE64", "XX");
      formData.append("DOC_CODE", formik.values.EmpId);
      formData.append("DOC_TYPE", "EMPIMAGE");
      formData.append("file", photoFile); // Employee Image must be sent as file!
      formData.append("cmpcode", companyCode);
      // formData.append('IMAGEPATH', docPath[0].imagepath)
      // PostEmpImagePath
      let postEmpImagePath = localStorage.getItem("PostEmpImagePath");
      console.log("postEmpImagePath:", postEmpImagePath);
      console.log("postEmpImagePath:", `${postEmpImagePath}BONDTIME_EMP_IMG\\`);

      // Step 1: Clean up postEmpImagePath by removing extra quotes and trimming spaces
      let basePath = postEmpImagePath.replace(/['"]+/g, "").trim();

      // Step 2: Ensure it ends with a single backslash
      if (!basePath.endsWith("\\")) {
        basePath += "\\";
      }

      // Step 3: Append subfolder
      // const fullPath = `c:\\fileupload_common\\BONDTIME_EMP_IMG\\`;
      const fullPath = `${basePath}BONDTIME_EMP_IMG\\`;

      // Step 4: Add to formData
      formData.append("IMAGEPATH", fullPath);

      // Debug
      console.log("fullPath:", fullPath);

      // Axios configuration
      const config = {
        headers: {
          "Content-Type": "multipart/form-data", // Ensure the correct content type
        },
      };

      console.log("formData", formData);

      // Send the POST request
      // Hard coded api to work photo post api 03-06-2025 //////////////////////////////////////////////////////////
      // const response = await axios.post(`${base_url_image_post_api}/Posts`, formData, config);

      const response = await axios.post(
        `${base_url_image_post_api}/api/Image/upload`,
        formData,
        config,
      );

      // const response = await axios.post(
      //   formData,
      //   config
      // );

      // Handle response
      console.log("Response1:", response.data);

      if (response.status == 200) {
        // toast.success("Image uploaded successfully");
        showSnackbar("success", "Image uploaded successfully");
        // changes made here Hard coded api to work photo post api 03-06-2025 //////////////////////////////////////////////////////////
        setImageDescription("");
        setPhoto("");
        setPhototFile("");

        fetchProfilePicData();
      }
      // return response.data;
    } catch (error) {
      // Handle error
      console.error("Error uploading data:", error.response || error.message);
      // toast.error("Some error occured");
      showSnackbar("error", "Some error occurred");
      // throw error;
    }
  };

  const fetchDocData = async (empId) => {
    try {
      const response = await axios.get(
        `${base_url}/api/cpayscount/${companyCode}/image/${empId}/DOCIMAGE`,
      );

      if (response.status === 200) {
        setUserDocHistory(response.data);
      }
    } catch (error) {
      console.log("fetchDocDataErr", error);
    }
  };

  const fetchData = async () => {
    try {
      const storedUserDataArray = localStorage.getItem("BondTimeLoginUserData");
      const parsedUserDataArray = JSON.parse(storedUserDataArray) || [];

      setUserDataArray(parsedUserDataArray);

      setLoginUser(
        parsedUserDataArray && parsedUserDataArray[0].salesman_name.trim(),
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleHistoryDocClick = (fileName) => {
    try {
      console.log(
        `base URL::,${base_url_image_view_api}/BONDTIME_DOC_IMG/${fileName}`,
      );

      const fileURL = `${base_url_image_view_api}/BONDTIME_DOC_IMG/${fileName}`;
      window.open(fileURL, "_blank"); // Opens the PDF in a new tab
    } catch (error) {
      console.log("handleHistoryDocClickErr", error);
    }
  };

  const fetchProfilePic = async (task_owner_id) => {
    // console.log('task_owner_id:',task_owner_id)
    try {
      const response = await fetch(
        // 213
        `${base_url}/api/cpayscount/${companyCode}/image/${task_owner_id}/EMPIMAGE`,
        // `${base_url_image_view_api}/api/cpayscount/${companyCode}/image/${task_owner_id}/EMPIMAGE`
        // 229
        // `${base_url_image_view_api}/api/cpayscount/${companyCode}/image/${task_owner_id}/EMPIMAGE`
      );

      const data = await response.json();
      // console.log("fetchProfilePic", data); // Log the response to check its structure
      if (data && data.length > 0 && data[data.length - 1].Imagepath) {
        // Extract the file name and extension from the last entry
        const filePath = data[data.length - 1].Imagepath.replace(/\\/g, "/");
        const fileName = filePath.split("/").pop(); // Extracts the last part (filename with extension)

        // Construct the full URL for the image
        // Hard coded api to work photo post api 03-06-2025  /////////////////////////////////////////////////

        return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
      }
    } catch (error) {
      console.error(
        `Error fetching profile image for ID ${task_owner_id}:`,
        error,
      );
    }
    return user2; // Return default image if fetching fails
  };

  const fetchProfilePicData = async () => {
    // console.log('empState?.EmpId',empState?.EmpId)
    const profilePicUrl = await fetchProfilePic(empState?.EmpId);
    // console.log()
    setPhotoUrl(profilePicUrl);
    // console.log("profilePicUrl", profilePicUrl); // Log the URL for debugging
    // You can then update the state to store the fetched image URL
    // Example: setProfileImage(profilePicUrl);
  };

  useEffect(() => {
    if (empState?.EmpId) {
      fetchProfilePicData(); // Call the async function
      fetchDocData(empState?.EmpId);
    }
  }, [empState?.EmpId]); // This hook runs whenever `empState.EmpId` changes

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (loginUser) {
      // console.log("fetchImagePath calling");
      fetchImagePath();
      fetchDocPath();
    }
  }, [loginUser]);

  // console.log('empEditPostData', empEditPostData)

  // console.log("photo", photo);
  // console.log("photoUrl", photoUrl);

  const clickedOnOfficeCheckin = (valueFromClick) => {
    formik.setFieldValue("onlineallow", valueFromClick);
  };

  const clickedOnDepartment = (valueFromClick) => {
    formik.setFieldValue("Department", valueFromClick);
  };

  // useEffect(() => {
  //   console.log("branchNameInInputBoxEdit ", branchNameInInputBoxEdit);
  // }, [branchNameInInputBoxEdit]);

  const newBranchAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/DEPARTMENT/${branchNameInInputBoxNew.branch_name}/ED54A276-A746-4649-B085-43CBBAEB7374`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDepartmentList();
        setBranchNameInInputBoxNew(initialBranchInAction);
      }, {})
      .catch((err) => {});
  };
  const newDepartmentAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/DEPT/${departmentNameInInputBoxNew.branch_name}/ED54A276-A746-4649-B085-43CBBAEB7374`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDeptList();
        setDepartmentNameInInputBoxNew(initialDepartmentInAction);
      }, {})
      .catch((err) => {});
  };

  // division
  const newDivisionAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/DIVISION/${divisionNameInInputBoxNew.division_name}/${initialDivisionInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDivisionList();
        setDivisionNameInInputBoxNew(initialDivisionInAction);
      }, {})
      .catch((err) => {});
  };

  const newGradeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/GRADE/${gradeNameInInputBoxNew.branch_name}/ED54A276-A746-4649-B085-43CBBAEB7374`;

    axios
      .post(apiUrl)
      .then((res) => {
        getGradeList();
        setGradeNameInInputBoxNew(initialGradeInAction);
      }, {})
      .catch((err) => {});
  };

  const editBranchAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/DEPARTMENT/${branchNameInInputBoxEdit.branch_name}/${branchNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDepartmentList();
        setBranchNameInInputBoxEdit(initialBranchInActionEdit);
      }, {})
      .catch((err) => {});
  };
  const editDepartmentAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/DEPT/${departmentNameInInputBoxEdit.branch_name}/${departmentNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDeptList();
        setDepartmentNameInInputBoxEdit(initialDepartmentInActionEdit);
      }, {})
      .catch((err) => {});
  };

  // division
  const editDivisionAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/DIVISION/${divisionNameInInputBoxEdit.division_name}/${divisionNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDivisionList();
        setDivisionNameInInputBoxEdit(initialDivisionInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const editGradeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/GRADE/${gradeNameInInputBoxEdit.branch_name}/${gradeNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getGradeList();
        setGradeNameInInputBoxEdit(initialGradeInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const deleteBranchAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/DELETE/${companyCode}/DEPARTMENT/${branchNameInInputBoxEdit.branch_name}/${branchNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDepartmentList();
        setBranchNameInInputBoxEdit(initialBranchInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const deleteDepartmentAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/DELETE/${companyCode}/DEPT/${departmentNameInInputBoxEdit.branch_name}/${departmentNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDeptList();
        setDepartmentNameInInputBoxEdit(initialDepartmentInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const deleteGradeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/DELETE/${companyCode}/GRADE/${gradeNameInInputBoxEdit.branch_name}/${gradeNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getGradeList();
        setGradeNameInInputBoxEdit(initialGradeInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const [isContactExpanded, setIsContactExpanded] = useState(false);
  const [isDocumentsExpanded, setIsDocumentsExpanded] = useState(false);
  const [isLeaveExpanded, setIsLeaveExpanded] = useState(false);

  const calculateAge = (dob) => {
    if (!dob) return "";
    const birthDate = dayjs(dob);
    const today = dayjs();
    return today.diff(birthDate, "year");
  };

  const [isPersonalEditing, setIsPersonalEditing] = useState(false);
  const [isContactEditing, setIsContactEditing] = useState(false);
  const [isEmploymentEditing, setIsEmploymentEditing] = useState(false);
  const [isDocumentsEditing, setIsDocumentsEditing] = useState(false);
  const [isSalaryEditing, setIsSalaryEditing] = useState(false);
  const [isGPSEditing, setIsGPSEditing] = useState(false);
  const [isLeaveDisabled, setIsLeaveDisabled] = useState(false);
  // JobTitle
  const [showJobTitleCreationEditPopup, setShowJobTitleCreationEditPopup] =
    useState(false);

  // division
  const [showDivisionCreationEditPopup, setShowDivisionCreationEditPopup] =
    useState(false);

  const navigate = useNavigate();

  const navigateToList = () => {
    setTimeout(() => {
      navigate(`/admin/emp_list`);
    }, 1000);
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleAccountSelect = (e, account) => {
    e.preventDefault();
    // console.log("Selected account:", account);
    formik.setFieldValue("SalaryAc", account);
  };

  const handleSalaryExpenseSelect = (e, salaryExpense) => {
    e.preventDefault();
    // console.log("Selected salaryExpense:", salaryExpense);
    formik.setFieldValue("AdvanceAc", salaryExpense);
  };

  const handleLoansAdvancesSelect = (e, loansAdvance) => {
    e.preventDefault();
    // console.log("Selected loansAdvance:", loansAdvance);
    formik.setFieldValue("Notes", loansAdvance);
  };

  const [searchParams] = useSearchParams();

  const handleAllowanceValuesChange = (values) => {
    // setEmp(values.EmpId);
    setAllowanceDataFromChild(values.allowances);
    // console.log("values from alowance to parent1 :", values.allowances);
  };
  const handleIncrementValuesChange = (values) => {
    setIncrementsDataFromChild(values.increments);
    // console.log("values from increments to parent1 :", values.increments);
  };

  // JobTitle
  const initialJobTitleInAction = {
    jobTitle_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7376", // dummy transaction id
    mode: "ENTRY",
  };

  // division
  const initialDivisionInAction = {
    division_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7375", // dummy transaction id
    mode: "ENTRY",
  };

  // JobTitle
  const initialJobTitleInActionEdit = {
    jobTitle_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // division
  const initialDivisionInActionEdit = {
    division_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // JobTitle
  const [jobTitleNameInInputBoxEdit, setJobTitleNameInInputBoxEdit] = useState(
    initialJobTitleInActionEdit,
  );

  // division
  const [divisionNameInInputBoxEdit, setDivisionNameInInputBoxEdit] = useState(
    initialDivisionInActionEdit,
  );

  // jobTitleList
  const [jobTitleListFromAPI, setJobTitleListFromAPI] = useState(null);

  // division
  const [divisionListFromAPI, setDivisionListFromAPI] = useState(null);

  // grade
  const [gradeListFromAPI, setGradeListFromAPI] = useState(null);

  // shiftGroup
  const [shiftGroupListFromAPI, setShiftGroupListFromAPI] = useState(null);

  // JobTitle
  const [jobTitleNameInInputBoxNew, setJobTitleNameInInputBoxNew] = useState(
    initialJobTitleInAction,
  );

  // division
  const [divisionNameInInputBoxNew, setDivisionNameInInputBoxNew] = useState(
    initialDivisionInAction,
  );

  // JobTitle
  const editJobTitleAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/JOBTITLE/${jobTitleNameInInputBoxEdit.jobTitle_name}/${jobTitleNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getJobTitleList();
        setJobTitleNameInInputBoxEdit(initialJobTitleInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const getJobTitleList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/JOBTITLE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setJobTitleListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getDivisionList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DIVISION/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDivisionListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getGradeList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setGradeListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getShiftGroupList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/SHIFTGROUP/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setShiftGroupListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  // JobTitle
  const newJobTitleAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/JOBTITLE/${jobTitleNameInInputBoxNew.jobTitle_name}/${initialJobTitleInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getJobTitleList();
        setJobTitleNameInInputBoxNew(initialJobTitleInAction);
      }, {})
      .catch((err) => {});
  };

  //ShiftGroup
  const newShiftGroupAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/SHIFTGROUP/${shiftGroupNameInInputBoxNew.shiftGroup_name}/${initialShiftGroupInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getShiftGroupList();
        setShiftGroupNameInInputBoxNew(initialShiftGroupInAction);
      }, {})
      .catch((err) => {});
  };

  const onBack = (e) => {
    e.preventDefault();
    // Pass the same query parameters received from Employee
    const queryParams = new URLSearchParams({
      jobTitle: searchParams.get("jobTitle") || "",
      grade: searchParams.get("grade") || "",
      division: searchParams.get("division") || "",
    }).toString();
    navigate(`/admin/emp_list?${queryParams}`);
  };

  const onPrint = (e) => {
    e.preventDefault();
    // Pass the same query parameters received from Employee
    const queryParams = new URLSearchParams({
      jobTitle: searchParams.get("jobTitle") || "",
      grade: searchParams.get("grade") || "",
      division: searchParams.get("division") || "",
    }).toString();
    // navigate(`/admin/editEmpPrint?${queryParams}`);
    navigate("/admin/editEmpPrint", {
      state: {
        empState,
      },
    });
  };

  const statusValue = formik.values.Status?.toLowerCase().trim();

  // useEffect(() => {
  //   if (empState?.EmpId) {
  //     getAllowanceList(empState.EmpId);
  //     getIncrementList(empState.EmpId);
  //     // console.log("emp id in edit:", empState.EmpId);
  //   }
  // }, [empState]);

  // useEffect(() => {
  //   if (!empState?.EmpId) return;

  //   getAllowanceList(empState.EmpId);
  //   getIncrementList(empState.EmpId);
  // }, [empState?.EmpId]);

  const getAllowanceList = async (EmpIdTop) => {
    // console.log("getAllowanceList called:",AlvTotal);
    const response = await axios.get(
      // `${base_url}/api/MASTERLIST/${companyCode}/PersonalInfoAllowanceReg/-`,
      `${base_url}/api/PersonalInfoAllowanceList/${companyCode}/${EmpIdTop}`,
    );
    // console.log("getAllowanceList response?.data:", response?.data);
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      // console.log("getAllowanceList newArray:", newArray);
      let allowancesSum = newArray?.reduce((a, v) => (a = a + v.Amount), 0);
      // console.log("getAllowanceList newArray: allowancesSum", AllowancesSum);

      setAllowanceData(newArray);
      setAllowanceAmountSum(allowancesSum);
    } else {
      console.log("error");
    }
  };

  const getIncrementList = async (EmpIdTop) => {
    // console.log("getIncrementList called:");
    const response = await axios.get(
      `${base_url}/api/PersonalInfoIncrementList/${companyCode}/${EmpIdTop}`,
    );
    // console.log("getIncrementList response?.data:", response?.data);
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );
      let incrementSum = newArray?.reduce((a, v) => (a = a + v.Amount), 0);
      setIncrementData(newArray);
      setIncrementAmountSum(incrementSum);
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    if (!isPayrollExpanded || !empState?.EmpId) return;

    const loadPayroll = async () => {
      setIsPayrollLoading(true);

      try {
        await Promise.all([
          getAllowanceList(empState.EmpId),
          getIncrementList(empState.EmpId),
        ]);
      } finally {
        setIsPayrollLoading(false);
      }
    };

    loadPayroll();
  }, [isPayrollExpanded, empState?.EmpId]);

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-4 text-slate-900 sm:px-6 lg:px-8">
      {empState && (
        <>
          <form action="" onSubmit={formik.handleSubmit}>
            <div className="mx-auto max-w-[1600px] bg-slate-50">
              <div className="sticky top-0 z-50 mb-4 flex flex-col gap-3 border-b border-slate-200 bg-slate-50/95 py-4 backdrop-blur md:flex-row md:items-center md:justify-between">
                {/* <div className="flex justify-between items-center mb-4"> */}
                {/* <h6 className=" text-2xl font-bold text-slate-600 flex  justify-start items-center">
                  <EditIcon className="mr-2" />
                  <span>
                    Edit Employee : {empState.EmpId ? empState.EmpId : null}
                  </span>
                </h6> */}
                <div className="flex items-center gap-3">
                  <div className="h-10 w-1 rounded-full bg-blue-600"></div>

                  <h6 className="flex flex-wrap items-center gap-2 text-xl font-semibold tracking-tight text-slate-900">
                    {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-600 to-blue-700 text-white shadow-sm">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
                    {/* <EditIcon className="text-blue-600" />  */}
                    <span>Edit Employee</span>
                    <span className="rounded-full border border-blue-100 bg-blue-50 px-3 py-1 text-sm font-medium text-blue-700">
                      {empState.EmpId ? empState.EmpId : null}
                    </span>
                  </h6>
                </div>

                {/* <button
                  className="bg-[#4B5563] rounded px-2 py-1 rounded text-white"
                  onClick={(e) => onBack(e)}
                >
                  Back
                </button> */}
                <div className="flex flex-wrap items-center gap-2">
                  <button
                    type="submit"
                    className="flex items-center gap-2 bg-emerald-600 hover:bg-green-800 
             text-white px-4 py-2 rounded-xl 
             transition-all duration-200 
             shadow-sm hover:shadow-sm"
                  >
                    <IoSaveOutline className="text-lg" />
                    Update
                  </button>
                  <button
                    type="button"
                    onClick={onPrint}
                    className="inline-flex items-center gap-2 rounded-xl bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    <IoPrintOutline className="text-lg" />
                    Print
                  </button>
                  <button
                    type="button"
                    onClick={onBack}
                    className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm transition-all duration-200 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    <IoArrowBack className="text-lg" />
                    Back
                  </button>
                </div>
              </div>

              {/* <div className="d-flex ">
                <div>
                  <div className="mt-3">
                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      placeholder="Password"
                      onChange={formik.handleChange("password")}
                      onBlur={formik.handleBlur("password")}
                      value={formik.values.password}
                      style={{ width: "100px" }}
                    />
                    <div className="error">
                      {formik.touched.password && formik.errors.password}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="mt-3 ms-2">
                    <input
                      type="text"
                      name="AlternateID"
                      className="form-control"
                      placeholder="AlternateID"
                      onChange={formik.handleChange("AlternateID")}
                      onBlur={formik.handleBlur("AlternateID")}
                      value={formik.values.AlternateID}
                      style={{ width: "100px" }}
                    />
                  </div>
                </div>
              </div> */}
              <div className="mb-4 grid grid-cols-1 gap-4">
                <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
                  {/* <div> */}
                  <Card className="rounded-2xl border border-slate-200 shadow-sm">
                    <CardContent sx={{ paddingBottom: 0 }}>
                      <div className="w-full flex flex-col md:flex-row justify-between items-center gap-6">
                        {/* Upload Section */}
                        <div className=" flex justify-center items-center ">
                          <div className="">
                            {/* Preview Section */}
                            {photo && (
                              <div className="mt-2">
                                <img
                                  src={photo}
                                  // src={user2}
                                  alt="Preview"
                                  className="h-20 w-20 rounded-2xl border border-slate-200 object-cover shadow-sm"
                                />
                              </div>
                            )}

                            {!photo && photoUrl && (
                              <div className="h-16 w-16 overflow-hidden rounded-full border border-slate-200 shadow-sm ring-4 ring-slate-50">
                                <img
                                  src={photoUrl}
                                  alt="PreviewUrl"
                                  className="h-16 w-16 rounded-full object-cover"
                                />
                              </div>
                            )}
                          </div>

                          <div className=" flex justify-center items-center gap-2">
                            <div className="ml-4">
                              <label
                                htmlFor="PhotoUpload"
                                className="block text-sm font-medium text-slate-600"
                              >
                                Upload Photo
                              </label>
                            </div>
                            <div>
                              <input
                                id="PhotoUpload"
                                type="file"
                                accept="image/*"
                                onChange={handlePhotoUpload}
                                className="block w-full cursor-pointer text-sm text-slate-500 file:mr-4 file:rounded-xl file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-medium file:text-blue-700 hover:file:bg-blue-100"
                              />
                            </div>

                            <div>
                              {/* Submit Button */}
                              <button
                                type="button"
                                onClick={sendUserImage}
                                className="inline-flex items-center rounded-xl bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                              >
                                Submit Photo
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                  {/* </div> */}
                  {/* <div className=""> */}
                  <Card className="rounded-2xl border border-slate-200 shadow-sm">
                    <CardContent sx={{ paddingBottom: 0 }}>
                      {/* <div className="flex flex-col md:flex-row justify-center items-start md:items-center gap-6 w-full"> */}
                      {/* Document Preview (optional file info) */}
                      <div className=" flex justify-center items-center ">
                        <div className="text-sm text-slate-600 space-y-1">
                          {userDoc && (
                            <div>
                              <p>
                                <strong>Selected File:</strong> {userDoc.name}
                              </p>
                              <p>
                                <strong>Type:</strong> {userDoc.type}
                              </p>
                            </div>
                          )}

                          {/* Document History List */}
                          {userDocHistory?.length > 0 && (
                            <div className="mt-2 space-y-1">
                              {userDocHistory.map((item, index) => {
                                const fileName =
                                  item.Imagepath.split("\\").pop();
                                return (
                                  <button
                                    key={index}
                                    onClick={() =>
                                      handleHistoryDocClick(fileName)
                                    }
                                    className="block rounded-lg px-2 py-1 text-left text-sm font-medium text-blue-600 transition hover:bg-blue-50"
                                  >
                                    {fileName}
                                  </button>
                                );
                              })}
                            </div>
                          )}
                        </div>

                        {/* Upload & Submit Controls */}

                        {/* <div className="flex flex-col md:flex-row items-center gap-4 w-auto"> */}
                        {/* Upload Label + Input */}

                        <div className="mt-2 mx-2">
                          <img
                            src={docPhoto}
                            alt="Preview"
                            className="h-14 w-16 rounded-xl object-contain"
                          />
                        </div>

                        <div className="flex justify-center items-center gap-2">
                          <label
                            htmlFor="DocumentUpload"
                            className="ml-4 block text-sm font-medium text-slate-600"
                          >
                            Upload Document
                          </label>
                          <input
                            id="DocumentUpload"
                            type="file"
                            onChange={handleDocumentUpload}
                            className="block w-full cursor-pointer text-sm text-slate-500 file:mr-4 file:rounded-xl file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-medium file:text-blue-700 hover:file:bg-blue-100"
                          />
                        </div>

                        {/* Submit Button */}
                        <button
                          type="button"
                          onClick={sendUserDoc}
                          className="inline-flex items-center rounded-xl bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                          Submit Document
                        </button>
                      </div>

                      {/* </div> */}
                    </CardContent>
                  </Card>
                  {/* </div> */}
                </div>
              </div>
              <div className="grid min-h-screen grid-cols-1 gap-4 lg:grid-cols-3">
                <div className="space-y-4 lg:col-span-2">
                  <Card className="rounded-2xl border border-slate-200 shadow-sm">
                    <CardContent className="relative">
                      <div className="flex justify-between items-center mb-3">
                        <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 gap-2">
                          <Badge className="text-blue-600 mb-1" /> PERSONAL
                          INFORMATION
                        </h2>
                        <IconButton
                          onClick={() => setIsPersonalEditing((prev) => !prev)}
                        >
                          <EditIcon />
                        </IconButton>
                      </div>
                      <div className="mb-6 flex items-center justify-between gap-4">
                        {/* <div className="absolute top-4 right-4">
                          <IconButton
                            onClick={() =>
                              setIsPersonalEditing((prev) => !prev)
                            }
                          >
                            <EditIcon />
                          </IconButton>
                        </div> */}

                        {/* <TailwindTextField
                                  label="Employee ID"
                                  name="empId"
                                  value={formik.values.EmpId}
                                  onChange={(e) => setEmpIdTop(e.target.value)}
                                  variant="outlined"
                                  // fullWidth
                                  InputProps={{
                                    startAdornment: <Work className="text-[#757575] mr-2" />,
                                  }}
                                  error={formik.touched.EmpId && Boolean(formik.errors.EmpId)}
                                  helperText={formik.touched.EmpId && formik.errors.EmpId}
                                /> */}
                        <div className="w-[18%]">
                          <TailwindTextField
                            readOnly
                            disabled
                            label="Employee ID"
                            name="EmpId"
                            // fullWidth
                            value={formik.values.EmpId}
                            // onChange={(e) => {
                            //   formik.handleChange(e);
                            //   setEmpIdTop(e.target.value);
                            // }}
                            onBlur={formik.handleBlur}
                            variant="outlined"
                            InputProps={{
                              startAdornment: (
                                <Work className="text-[#757575] mr-2" />
                              ),
                            }}
                            error={
                              formik.touched.EmpId &&
                              Boolean(formik.errors.EmpId)
                            }
                            helperText={
                              formik.touched.EmpId && formik.errors.EmpId
                            }
                          />
                        </div>

                        {/* Password */}
                        <TailwindTextField
                          // type="password"
                          label="App Password"
                          name="password"
                          onChange={formik.handleChange("password")}
                          onBlur={formik.handleBlur("password")}
                          value={formik.values.password}
                          variant="outlined"
                          // fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <VpnKey className="text-[#757575] mr-2" />
                            ),
                          }}
                        />

                        {/* Active */}
                        <div className="flex justify-between items-center gap-2 w-[28%]">
                        <FormControl
                          fullWidth
                          disabled={!isPersonalEditing}
                          variant="outlined"
                          error={
                            formik.touched.Active &&
                            Boolean(formik.errors.Active)
                          }
                          className="w-30"
                        >
                          <InputLabel id="active-label">Active</InputLabel>
                          <Select
                            labelId="active-label"
                            id="Active"
                            name="Active"
                            value={formik.values.Active}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            startAdornment={
                              <CheckCircle className="mr-2 text-[#757575]" />
                            }
                            label="Active"
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                          {formik.touched.Active && formik.errors.Active && (
                            <p className="text-red-500 text-sm mt-1">
                              {formik.errors.Active}
                            </p>
                          )}
                        </FormControl>
                        </div>

                        <div className="flex justify-between items-center gap-2 w-[28%]">
                          {/* <FormControl
                            fullWidth
                            variant="outlined"
                            disabled={!isPersonalEditing}
                            sx={
                              !isPersonalEditing
                                ? {
                                    cursor: "not-allowed",
                                    pointerEvents: "none",
                                  }
                                : {}
                            }
                            error={
                              formik.touched.Status &&
                              Boolean(formik.errors.Status)
                            }
                          >
                            <InputLabel shrink>Status</InputLabel>

                            <Select
                              name="Status"
                              // value={formik.values.Status || ""}
                              value={
                                statusValue === "confirmed"
                                  ? "Confirmed Employee"
                                  : statusValue === "probation"
                                    ? "Probation"
                                    : ""
                              }
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              label="Status"
                              // displayEmpty
                              disabled={!isPersonalEditing}
                            >
                              <MenuItem value="">
                                <em>Select Status</em>
                              </MenuItem>

                              <MenuItem value="Confirmed Employee">
                                Confirmed Employee
                              </MenuItem>

                              <MenuItem value="Probation">Probation</MenuItem>
                            </Select>
                          </FormControl> */}
                          {/* {formik.touched.Status && formik.errors.Status && (
                            <p className="text-red-500 text-sm mt-1">
                              {formik.errors.Status}
                            </p>
                          )} */}
                          {/* <button
                            type="button"
                            // onClick={() => setShowStatusCreationEditPopup(true)}
                            className="bg-blue-600 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-xl"
                          >
                            Manage
                          </button> */}
                          <FormControl
                            fullWidth
                            variant="outlined"
                            disabled={!isPersonalEditing}
                            error={
                              formik.touched.Status &&
                              Boolean(formik.errors.Status)
                            }
                          >
                            <InputLabel shrink>Status</InputLabel>

                            <Select
                              name="Status"
                              value={formik.values.Status || ""}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              label="Status"
                            >
                              <MenuItem value="">
                                <em>Select Status</em>
                              </MenuItem>

                              {statusListFromAPI?.map((item) => (
                                <MenuItem
                                  key={item.TranId}
                                  value={item.Description}
                                >
                                  {item.Description}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-4 gap-6 text-sm text-slate-600">
                        {/* Title */}
                        {/* Title - Reduced Width */}

                        {/* First Name */}
                        <TailwindTextField
                          label="First Name"
                          name="FistName"
                          value={formik.values.FistName}
                          onChange={formik.handleChange("FistName")}
                          onBlur={formik.handleBlur("FistName")}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <AccountCircle className="text-[#757575] mr-2" />
                            ),
                          }}
                          error={
                            formik.touched.FistName &&
                            Boolean(formik.errors.FistName)
                          }
                          helperText={
                            formik.touched.FistName && formik.errors.FistName
                          }
                        />

                        {/* Middle Name */}
                        <TailwindTextField
                          label="Middle Name"
                          name="MiddleName"
                          value={formik.values.MiddleName}
                          onChange={formik.handleChange("MiddleName")}
                          onBlur={formik.handleBlur("MiddleName")}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <AccountCircle className="text-[#757575] mr-2" />
                            ),
                          }}
                        />

                        {/* Last Name */}
                        <TailwindTextField
                          label="Last Name"
                          name="LastName"
                          value={formik.values.LastName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <AccountCircle className="text-[#757575] mr-2" />
                            ),
                          }}
                          error={
                            formik.touched.LastName &&
                            Boolean(formik.errors.LastName)
                          }
                          helperText={
                            formik.touched.LastName && formik.errors.LastName
                          }
                        />

                        <FormControl
                          variant="outlined"
                          sx={{ minWidth: 50, width: "100%" }}
                        >
                          <InputLabel id="title-label">Title</InputLabel>
                          <Select
                            labelId="title-label"
                            name="Title"
                            className="w-full"
                            value={formik.values.Title}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled={!isPersonalEditing}
                            onClick={(e) => {
                              if (isPersonalEditing == true) {
                                e.preventDefault(); // 🛑 block dropdown from opening
                              }
                            }}
                            sx={{
                              "& .MuiSelect-select": {
                                paddingLeft: "36px",
                                cursor: !isPersonalEditing
                                  ? "not-allowed"
                                  : "pointer", // 🖱 cursor effect
                              },
                            }}
                            tabIndex={isPersonalEditing ? 0 : -1} // optional: block tab focus
                            startAdornment={
                              <Badge className="absolute left-2 text-[#757575]" />
                            }
                            label="Title"
                          >
                            <MenuItem value="">
                              <em>Title</em>
                            </MenuItem>
                            <MenuItem value="Mr">Mr</MenuItem>
                            <MenuItem value="Ms">Ms</MenuItem>
                            <MenuItem value="Mrs">Mrs</MenuItem>
                          </Select>
                        </FormControl>

                        {/* AlternateID */}
                        <TailwindTextField
                          label="Alternate ID"
                          name="AlternateID"
                          onChange={formik.handleChange("AlternateID")}
                          onBlur={formik.handleBlur("AlternateID")}
                          value={formik.values.AlternateID}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <AlternateEmail className="text-[#757575] mr-2" />
                            ),
                          }}
                        />
                        {/* <TailwindTextField
                          label="Alternate ID"
                          name="AlternateID"
                          value={formik.values.AlternateID}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <AlternateEmail className="text-[#757575] mr-2" />
                            ),
                          }}
                        /> */}

                        {/* <TailwindTextField
                          // type="password"
                          label="Password"
                          name="password"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.password}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <VpnKey className="text-[#757575] mr-2" />
                            ),
                          }}
                        /> */}
                        {/* Employee ID */}

                        {/* Gender */}
                        <FormControl
                          fullWidth
                          disabled={!isPersonalEditing}
                          variant="outlined"
                          error={
                            formik.touched.Gender &&
                            Boolean(formik.errors.Gender)
                          }
                        >
                          <InputLabel id="gender-label">Gender</InputLabel>
                          <Select
                            labelId="gender-label"
                            name="Gender"
                            value={formik.values.Gender}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            startAdornment={
                              <Wc className="mr-2 text-[#757575]" />
                            }
                            label="Gender"
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                          </Select>
                          {formik.touched.Gender && (
                            <FormHelperText>
                              {formik.errors.Gender}
                            </FormHelperText>
                          )}
                        </FormControl>
                        {/* Nationality */}
                        <TailwindTextField
                          label="Nationality"
                          name="Nationality"
                          value={formik.values.Nationality}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <Language className="text-[#757575] mr-2" />
                            ),
                          }}
                          error={
                            formik.touched.Nationality &&
                            Boolean(formik.errors.Nationality)
                          }
                          helperText={
                            formik.touched.Nationality &&
                            formik.errors.Nationality
                          }
                        />
                        {/* Height */}
                        <TailwindTextField
                          label="Height"
                          name="Height"
                          value={formik.values.Height}
                          onChange={formik.handleChange("Height")}
                          onBlur={formik.handleBlur("Height")}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <HeightIcon className="text-[#757575] mr-2" />
                            ),
                          }}
                        />
                        {/* Weight */}
                        <TailwindTextField
                          label="Weight"
                          name="Weight"
                          type="number"
                          value={formik.values.Weight}
                          onChange={formik.handleChange("Weight")}
                          onBlur={formik.handleBlur("Weight")}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <MonitorWeight className="text-[#757575] mr-2" />
                            ),
                          }}
                        />
                        {/* Marital Status */}
                        {/* <TailwindTextField
                          label="Marital Status"
                          name="MaritalStatus"
                          value={formik.values.MaritalStatus}
                          onChange={formik.handleChange("MaritalStatus")}
                          onBlur={formik.handleBlur("MaritalStatus")}
                          variant="outlined"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputProps={{
                            readOnly: !isPersonalEditing,
                            sx: !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {},
                            startAdornment: (
                              <Favorite className="text-[#757575] mr-2" />
                            ),
                          }}
                        /> */}

                        <FormControl
                          fullWidth
                          variant="outlined"
                          disabled={!isPersonalEditing}
                          sx={
                            !isPersonalEditing
                              ? { cursor: "not-allowed", pointerEvents: "none" }
                              : {}
                          }
                        >
                          <InputLabel shrink>Marital Status</InputLabel>
                          <Select
                            name="MaritalStatus"
                            value={formik.values.MaritalStatus}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            startAdornment={
                              // <Favorite className="text-[#757575] mr-2" />
                              <Wc className="mr-2 text-[#757575]" />
                            }
                            label="Marital Status"
                            displayEmpty
                            readOnly={!isPersonalEditing}
                          >
                            <MenuItem value="" disabled>
                              Select Marital Status
                            </MenuItem>
                            <MenuItem value="Single">Single</MenuItem>
                            <MenuItem value="Married">Married</MenuItem>
                            <MenuItem value="Divorced">Divorced</MenuItem>
                            <MenuItem value="Widowed">Widowed</MenuItem>
                          </Select>
                        </FormControl>

                        <div className="flex justify-between items-center gap-2">
                          {/* Department (Branch) replaced to department , menu list data from API */}
                          <FormControl
                            fullWidth
                            variant="outlined"
                            error={
                              formik.touched.Department &&
                              Boolean(formik.errors.Department)
                            }
                            disabled={!isPersonalEditing}
                          >
                            {/* <InputLabel id="department-label">Branch</InputLabel> */}
                            <InputLabel id="department-label">
                              Department
                            </InputLabel>
                            <Select
                              labelId="department-label"
                              name="Department"
                              value={formik.values.Department}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              startAdornment={
                                <ApartmentIcon className="mr-2 text-slate-500" />
                              }
                              label="Department"
                            >
                              <MenuItem value="">
                                <em>Select Department</em>
                              </MenuItem>
                              {departmentLisFromAPI?.map((item, index) => (
                                <MenuItem key={index} value={item.Description}>
                                  {item.Description}
                                </MenuItem>
                              ))}
                            </Select>
                            {formik.touched.Department && (
                              <FormHelperText>
                                {formik.errors.Department}
                              </FormHelperText>
                            )}
                          </FormControl>

                          <button
                            type="button"
                            onClick={() =>
                              setShowDepartmentCreationEditPopup(true)
                            }
                            className="rounded-xl bg-blue-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Manage
                          </button>
                        </div>

                        {/* Department (Branch) replaced to department , menu list data from API */}
                        {/* <FormControl
                          fullWidth
                          disabled={!isPersonalEditing}
                          variant="outlined"
                          error={
                            formik.touched.Department &&
                            Boolean(formik.errors.Department)
                          }
                        >
                          {/* <InputLabel id="department-label">Branch</InputLabel> 
                          <InputLabel id="department-label">
                            Department
                          </InputLabel>
                          <Select
                            labelId="department-label"
                            name="Department"
                            value={formik.values.Department}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            startAdornment={
                              <GroupWork className="mr-2 text-slate-500" />
                            }
                          >
                            <MenuItem value="">
                              <em>Select Branch</em>
                            </MenuItem>
                            {departmentLisFromAPI?.map((item, index) => (
                              <MenuItem key={index} value={item.Description}>
                                {item.Description}
                              </MenuItem>
                            ))}
                          </Select>
                          {formik.touched.Department && (
                            <FormHelperText>
                              {formik.errors.Department}
                            </FormHelperText>
                          )}
                        </FormControl> */}
                        {/* Date of Birth */}
                        {/* // Inside your component */}
                        <TailwindTextField
                          id="dob"
                          label="Date Of Birth"
                          name="DOB"
                          type="date"
                          variant="outlined" // or "outlined" / "filled"
                          fullWidth
                          disabled={!isPersonalEditing}
                          InputLabelProps={{
                            shrink: true, // ensures the label doesn't overlap with date value
                          }}
                          value={formik.values.DOB?.substring(0, 10) || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.DOB && Boolean(formik.errors.DOB)
                          }
                          helperText={formik.touched.DOB && formik.errors.DOB}
                        />

                        <TailwindTextField
                          label="Join Date"
                          id="JoinDate"
                          type="date"
                          name="JoinDate"
                          // onFocus={(e) => (e.target.type = "date")}
                          // onChange={formik.handleChange("JoinDate")}
                          onChange={formik.handleChange}
                          // onBlur={formik.handleBlur("JoinDate")}
                          onBlur={formik.handleBlur}
                          // value={formik.values.JoinDate}
                          value={formik.values.JoinDate?.substring(0, 10) || ""}
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          disabled={!isPersonalEditing}
                          error={
                            formik.touched.JoinDate &&
                            Boolean(formik.errors.JoinDate)
                          }
                          helperText={
                            formik.touched.JoinDate && formik.errors.JoinDate
                          }
                        />

                        <FormControlLabel
                          control={
                            <Switch
                              checked={formik.values.onlineallow === "T"}
                              onChange={(e) =>
                                formik.setFieldValue(
                                  "onlineallow",
                                  e.target.checked ? "T" : "",
                                )
                              }
                              name="onlineallow"
                              color="primary"
                            />
                          }
                          label="Office Check-in Mandatory"
                        />
                        {/* Office Check-in Mandatory */}
                        {/* <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingBottom: "19px",
                            opacity: !isPersonalEditing ? 0.5 : 1, // 🔒 visually indicate it's disabled
                            pointerEvents: !isPersonalEditing ? "none" : "auto", // 🚫 block all interactions if disabled
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Switch
                                checked={formik.values.onlineallow === "T"}
                                onChange={(e) =>
                                  formik.setFieldValue(
                                    "onlineallow",
                                    e.target.checked ? "T" : ""
                                  )
                                }
                                name="onlineallow"
                                disabled={!isPersonalEditing}
                                color="primary"
                              />
                            }
                            // label="Office Check-in Mandatory"
                            label="Activate GeoFencing"
                          />
                          {formik.touched.onlineallow &&
                            formik.errors.onlineallow && (
                              <div className="text-red-500 text-sm mt-1">
                                {formik.errors.onlineallow}
                              </div>
                            )}
                        </div> */}
                      </div>
                    </CardContent>
                  </Card>
                  {/* //////////////////////contact info/////////////// */}
                  <Card className="rounded-2xl border border-slate-200 shadow-sm mt-4">
                    <CardContent className="relative">
                      <div className="absolute top-4 right-4">
                        <IconButton
                          onClick={() => setIsContactEditing((prev) => !prev)}
                        >
                          <EditIcon />
                        </IconButton>
                      </div>
                      {/* <h2 className="text-xl font-semibold text-slate-600 flex items-center justify-start mb-4 gap-2">
                        <PhoneIcon className="text-[#757575]" /> Contact &
                        Address Information
                      </h2> */}
                      <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                        <PhoneIcon className="text-blue-600" /> CONTACT &
                        ADDRESS
                      </h2>

                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-sm text-slate-600">
                        {/* Work Mobile */}
                        <TailwindTextField
                          label="Work Mobile"
                          // placeholder="Type Mobile Number Here"
                          name="WorkMobile"
                          id="WorkMobile"
                          type="number"
                          variant="outlined"
                          fullWidth
                          disabled={!isContactEditing}
                          className="inpBackColor"
                          value={formik.values.WorkMobile}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.WorkMobile &&
                            Boolean(formik.errors.WorkMobile)
                          }
                          helperText={
                            formik.touched.WorkMobile &&
                            formik.errors.WorkMobile
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIphoneIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Personal Phone */}
                        <TailwindTextField
                          // label="Personal Phone"
                          label="Emergency Phone"
                          // placeholder="Type Phone Number Here"
                          name="PersonalPhone"
                          id="PersonalPhone"
                          type="number"
                          variant="outlined"
                          fullWidth
                          disabled={!isContactEditing}
                          className="inpBackColor"
                          value={formik.values.PersonalPhone}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.PersonalPhone &&
                            Boolean(formik.errors.PersonalPhone)
                          }
                          helperText={
                            formik.touched.PersonalPhone &&
                            formik.errors.PersonalPhone
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Home Airport */}
                        <TailwindTextField
                          label="Home Airport"
                          // placeholder="Type Your Home Airport Here"
                          name="HomeAirport"
                          id="HomeAirport"
                          variant="outlined"
                          fullWidth
                          disabled={!isContactEditing}
                          className="inpBackColor"
                          value={formik.values.HomeAirport}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.HomeAirport &&
                            Boolean(formik.errors.HomeAirport)
                          }
                          helperText={
                            formik.touched.HomeAirport &&
                            formik.errors.HomeAirport
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FlightTakeoffIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Work Phone */}
                        <TailwindTextField
                          // label="Work Phone"
                          label="Personal Mobile"
                          // placeholder="Type Phone Number Here"
                          name="WorkPhone"
                          id="WorkPhone"
                          type="number"
                          variant="outlined"
                          fullWidth
                          disabled={!isContactEditing}
                          className="inpBackColor"
                          value={formik.values.WorkPhone}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.WorkPhone &&
                            Boolean(formik.errors.WorkPhone)
                          }
                          helperText={
                            formik.touched.WorkPhone && formik.errors.WorkPhone
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Personal Mobile */}
                        <TailwindTextField
                          // label="Personal Mobile"
                          label="Emergency Contact"
                          // placeholder="Type Mobile Number Here"
                          name="PersonalMobile"
                          id="PersonalMobile"
                          type="number"
                          variant="outlined"
                          fullWidth
                          disabled={!isContactEditing}
                          className="inpBackColor"
                          value={formik.values.PersonalMobile}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.PersonalMobile &&
                            Boolean(formik.errors.PersonalMobile)
                          }
                          helperText={
                            formik.touched.PersonalMobile &&
                            formik.errors.PersonalMobile
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIphoneIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Home Address */}
                        <TailwindTextField
                          label="Home Address"
                          // placeholder="Type Your Address Here"
                          name="HomeAddress"
                          id="HomeAddress"
                          variant="outlined"
                          fullWidth
                          disabled={!isContactEditing}
                          className="inpBackColor"
                          value={formik.values.HomeAddress}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.HomeAddress &&
                            Boolean(formik.errors.HomeAddress)
                          }
                          helperText={
                            formik.touched.HomeAddress &&
                            formik.errors.HomeAddress
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <HomeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Work Email */}
                        <TailwindTextField
                          label="Work Email"
                          // placeholder="Type Email Here"
                          name="WorkEmail"
                          id="WorkEmail"
                          variant="outlined"
                          fullWidth
                          disabled={!isContactEditing}
                          className="inpBackColor"
                          value={formik.values.WorkEmail}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.WorkEmail &&
                            Boolean(formik.errors.WorkEmail)
                          }
                          helperText={
                            formik.touched.WorkEmail && formik.errors.WorkEmail
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Personal Email */}
                        <TailwindTextField
                          label="Personal Email"
                          // placeholder="Type Email Here"
                          name="PersonalEmail"
                          id="PersonalEmail"
                          variant="outlined"
                          fullWidth
                          disabled={!isContactEditing}
                          className="inpBackColor"
                          value={formik.values.PersonalEmail}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.PersonalEmail &&
                            Boolean(formik.errors.PersonalEmail)
                          }
                          helperText={
                            formik.touched.PersonalEmail &&
                            formik.errors.PersonalEmail
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Current Address */}
                        <TailwindTextField
                          label="Current Address"
                          // placeholder="Type Your Address Here"
                          name="CurrentAddress"
                          id="CurrentAddress"
                          variant="outlined"
                          fullWidth
                          disabled={!isContactEditing}
                          className="inpBackColor"
                          value={formik.values.CurrentAddress}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.CurrentAddress &&
                            Boolean(formik.errors.CurrentAddress)
                          }
                          helperText={
                            formik.touched.CurrentAddress &&
                            formik.errors.CurrentAddress
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LocationOnIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    </CardContent>
                  </Card>
                  {/* //////////////////////employment overview///////// */}
                  <Card className="rounded-2xl border border-slate-200 shadow-sm mt-4">
                    <CardContent className="relative">
                      <div className="absolute top-4 right-4">
                        <IconButton
                          onClick={() =>
                            setIsEmploymentEditing((prev) => !prev)
                          }
                        >
                          <EditIcon />
                        </IconButton>
                      </div>
                      {/* <h2 className="text-xl font-semibold text-slate-600 flex items-center justify-start mb-4 gap-2">
                        <WorkIcon className="text-[#757575]" /> Employment
                        Overview
                      </h2> */}
                      <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                        <WorkIcon className="text-blue-600" /> EMPLOYMENT
                        OVERVIEW
                      </h2>

                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-sm text-slate-600">
                        {/* Join Date */}
                        {/* <TailwindTextField
                                label="Join Date"
                                type="date"
                                name="JoinDate"
                                id="JoinDate"
                                variant="outlined"
                                 fullWidth disabled={!isEmploymentEditing}

                                InputLabelProps={{ shrink: true }}
                                className="inpBackColor"
                                value={formik.values.JoinDate}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                // disabled={!isEditing}
                                error={
                                  formik.touched.JoinDate && Boolean(formik.errors.JoinDate)
                                }
                                helperText={formik.touched.JoinDate && formik.errors.JoinDate}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <EventIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              /> */}

                        {/* Shift Group */}
                        {/* <TailwindTextField
                          label="Shift Group"
                          name="ShiftGroup"
                          id="ShiftGroup"
                          variant="outlined"
                          fullWidth
                          disabled={!isEmploymentEditing}
                          className="inpBackColor"
                          value={formik.values.ShiftGroup}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <AccessTimeIcon />
                              </InputAdornment>
                            ),
                          }}
                        /> */}

                        <div className="flex justify-between items-center gap-2">
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="division-label">
                              Shift Group
                            </InputLabel>
                            <Select
                              disabled={!isEmploymentEditing}
                              labelId="division-label"
                              name="ShiftGroup"
                              value={formik.values.ShiftGroup}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              startAdornment={
                                <AccessTimeIcon className="mr-2 text-slate-500" />
                              }
                              label="Shift Group"
                            >
                              <MenuItem value="">
                                <em>Select Grade</em>
                              </MenuItem>
                              {shiftGroupListFromAPI?.map((item, index) => (
                                <MenuItem key={index} value={item.Description}>
                                  {item.Description}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <button
                            type="button"
                            disabled={!isEmploymentEditing}
                            onClick={() =>
                              setShowShiftGroupCreationEditPopup(true)
                            }
                            className={` px-2 py-1 font-semibold rounded-xl ${isEmploymentEditing ? "bg-blue-600 hover:bg-blue-700  text-white" : "bg-gray-300 hover:bg-gray-300  text-white"}`}
                          >
                            Manage
                          </button>
                        </div>

                        {/* Agent ID */}
                        <TailwindTextField
                          label="Agent ID"
                          name="AgentID"
                          id="AgentID"
                          variant="outlined"
                          fullWidth
                          disabled={!isEmploymentEditing}
                          className="inpBackColor"
                          value={formik.values.AgentID}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <BadgeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Job Title */}
                        {/* <div className="flex justify-center items-center gap-2">
                          <FormControl
                            variant="outlined"
                            fullWidth
                            disabled={!isEmploymentEditing}
                            // disabled={!isEditing}
                            error={
                              formik.touched.JobTitle &&
                              Boolean(formik.errors.JobTitle)
                            }
                          >
                            <InputLabel id="job-title-label">
                              Job Title
                            </InputLabel>
                            <Select
                              labelId="job-title-label"
                              id="JobTitle"
                              name="JobTitle"
                              value={formik.values.JobTitle}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              startAdornment={
                                <InputAdornment position="start">
                                  <WorkOutlineIcon />
                                </InputAdornment>
                              }
                              label="Job Title"
                            >
                              <MenuItem value="">
                                <em>Select Job</em>
                              </MenuItem>
                              {Array.isArray(empStatelist) &&
                                empStatelist.map((d, i) => (
                                  <MenuItem key={i} value={d.Description}>
                                    {d.Description}
                                  </MenuItem>
                                ))}
                            </Select>
                            {formik.touched.JobTitle &&
                              formik.errors.JobTitle && (
                                <div className="text-red-500 text-sm mt-1">
                                  {formik.errors.JobTitle}
                                </div>
                              )}

                            
                          </FormControl>
                          <Tooltip title="Add Item">
                            <IconButton
                              onClick={handleButtonClick}
                              disabled={!isEmploymentEditing}
                              className={`text-white !rounded-xl ${
                                !isEmploymentEditing
                                  ? "bg-gray-300 cursor-not-allowed"
                                  : "!bg-teal-600 hover:!bg-teal-700"
                              }`}
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                              data-bs-whatever="@mdo"
                            >
                              <MdFormatListBulletedAdd />
                            </IconButton>
                          </Tooltip>
                        </div> */}

                        {/* Job Title */}
                        <div className="flex justify-between items-center gap-2">
                          <FormControl
                            variant="outlined"
                            fullWidth
                            disabled={!isEmploymentEditing}
                            error={
                              formik.touched.JobTitle &&
                              Boolean(formik.errors.JobTitle)
                            }
                          >
                            <InputLabel id="job-title-label">
                              Job Title
                            </InputLabel>
                            <Select
                              labelId="job-title-label"
                              id="JobTitle"
                              name="JobTitle"
                              value={formik.values.JobTitle}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              startAdornment={
                                <InputAdornment position="start">
                                  <WorkOutlineIcon />
                                </InputAdornment>
                              }
                              label="Job Title"
                            >
                              <MenuItem value="">
                                <em>Select Job Title</em>
                              </MenuItem>
                              {/* {Array.isArray(empState) &&
                                empState.map((d, i) => (
                                  <MenuItem key={i} value={d.Description}>
                                    {d.Description}
                                  </MenuItem>
                                ))} */}
                              {Array.isArray(jobTitleListFromAPI) &&
                                jobTitleListFromAPI.map((d, i) => (
                                  <MenuItem key={i} value={d.Description}>
                                    {d.Description}
                                  </MenuItem>
                                ))}
                            </Select>
                            {formik.touched.JobTitle &&
                              formik.errors.JobTitle && (
                                <div className="text-red-500 text-sm mt-1">
                                  {formik.errors.JobTitle}
                                </div>
                              )}
                          </FormControl>

                          <button
                            type="button"
                            disabled={!isEmploymentEditing}
                            onClick={() =>
                              setShowJobTitleCreationEditPopup(true)
                            }
                            className={` px-2 py-1 font-semibold rounded-xl ${isEmploymentEditing ? "bg-blue-600 hover:bg-blue-700  text-white" : "bg-gray-300 hover:bg-gray-300  text-white"}`}
                          >
                            Manage
                          </button>
                        </div>

                        {/* Division */}
                        {/* <div className="flex justify-center items-center">
                          <TailwindTextField
                            // label="Department"
                            label="Division"
                            name="Division"
                            id="Division"
                            variant="outlined"
                            fullWidth
                            disabled={!isEmploymentEditing}
                            className="inpBackColor"
                            value={formik.values.Division}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            // disabled={!isEditing}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <ApartmentIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                          <IconButton
                            onClick={() =>
                              setShowDepartmentCreationEditPopup(
                                (prev) => !prev,
                              )
                            }
                            disabled={!isEmploymentEditing} // Add this to disable the button based on a condition
                            sx={{
                              backgroundColor: !isEmploymentEditing
                                ? "#d1d5db"
                                : "#f7f7f7", // Gray when disabled, original color when enabled
                              marginLeft: 1,
                              width: "50px",
                              height: "50px",
                              "&:hover": {
                                backgroundColor: !isEmploymentEditing
                                  ? "#d1d5db"
                                  : "#e5e7eb", // Consistent hover effect
                              },
                              "&.Mui-disabled": {
                                cursor: "not-allowed", // Indicate non-interactive state
                                opacity: 0.6, // Material-UI default disabled opacity
                              },
                            }}
                          >
                            <EditAttributesIcon />
                          </IconButton>
                        </div> */}

                        <div className="flex justify-between items-center gap-2">
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="division-label">
                              Division
                            </InputLabel>
                            <Select
                              labelId="division-label"
                              name="Division"
                              disabled={!isEmploymentEditing}
                              value={formik.values.Division}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              startAdornment={
                                <ApartmentIcon className="mr-2 text-slate-500" />
                              }
                              label="Division"
                            >
                              <MenuItem value="">
                                <em>Select Division</em>
                              </MenuItem>
                              {divisionListFromAPI?.map((item, index) => (
                                <MenuItem key={index} value={item.Description}>
                                  {item.Description}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <button
                            type="button"
                            disabled={!isEmploymentEditing}
                            onClick={() =>
                              setShowDivisionCreationEditPopup(true)
                            }
                            className={` px-2 py-1 font-semibold rounded-xl ${isEmploymentEditing ? "bg-blue-600 hover:bg-blue-700  text-white" : "bg-gray-300 hover:bg-gray-300  text-white"}`}
                          >
                            Manage
                          </button>
                        </div>

                        {/* Bank Name */}
                        <TailwindTextField
                          label="Bank Name"
                          name="BankName"
                          id="BankName"
                          variant="outlined"
                          fullWidth
                          disabled={!isEmploymentEditing}
                          className="inpBackColor"
                          value={formik.values.BankName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <AccountBalanceIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Job Type */}
                        <FormControl
                          variant="outlined"
                          fullWidth
                          disabled={!isEmploymentEditing}
                          className="inpBackColor"
                        >
                          <InputLabel id="job-type-label">
                            {/* <CategoryIcon style={{ marginRight: "6px", verticalAlign: "middle" }} /> */}
                            Job Type
                          </InputLabel>
                          <Select
                            labelId="job-type-label"
                            id="JobType"
                            name="JobType"
                            value={formik.values.JobType}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            startAdornment={
                              <InputAdornment position="start">
                                <CategoryIcon />
                              </InputAdornment>
                            }
                            label="Job Type"
                          >
                            <MenuItem value="Full Time">Full Time</MenuItem>
                            <MenuItem value="Part Time">Part Time</MenuItem>
                          </Select>
                        </FormControl>

                        {/* Grade */}
                        {/* <div className="flex justify-center items-center">
                          <TailwindTextField
                            label="Grade"
                            name="Grade"
                            id="Grade"
                            variant="outlined"
                            fullWidth
                            disabled={!isEmploymentEditing}
                            className="inpBackColor"
                            value={formik.values.Grade}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            // disabled={!isEditing}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <StarHalfIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                          <IconButton
                            onClick={() =>
                              setShowGradeCreationEditPopup((prev) => !prev)
                            }
                            disabled={!isEmploymentEditing} // Add this to disable the button based on a condition
                            sx={{
                              backgroundColor: !isEmploymentEditing
                                ? "#d1d5db"
                                : "#f7f7f7", // Gray when disabled, original color when enabled
                              marginLeft: 1,
                              width: "50px",
                              height: "50px",
                              "&:hover": {
                                backgroundColor: !isEmploymentEditing
                                  ? "#d1d5db"
                                  : "#e5e7eb", // Consistent hover effect
                              },
                              "&.Mui-disabled": {
                                cursor: "not-allowed", // Indicate non-interactive state
                                opacity: 0.6, // Material-UI default disabled opacity
                              },
                            }}
                          >
                            <EditAttributesIcon />
                          </IconButton>
                        </div> */}

                        <div className="flex justify-between items-center gap-2">
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="division-label">Grade</InputLabel>
                            <Select
                              labelId="division-label"
                              name="Grade"
                              disabled={!isEmploymentEditing}
                              value={formik.values.Grade}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              startAdornment={
                                <StarHalfIcon className="mr-2 text-slate-500" />
                              }
                              label="Division"
                            >
                              <MenuItem value="">
                                <em>Select Grade</em>
                              </MenuItem>
                              {gradeListFromAPI?.map((item, index) => (
                                <MenuItem key={index} value={item.Description}>
                                  {item.Description}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <button
                            type="button"
                            disabled={!isEmploymentEditing}
                            onClick={() => setShowGradeCreationEditPopup(true)}
                            className={` px-2 py-1 font-semibold rounded-xl ${isEmploymentEditing ? "bg-blue-600 hover:bg-blue-700  text-white" : "bg-gray-300 hover:bg-gray-300  text-white"}`}
                          >
                            Manage
                          </button>
                        </div>

                        <TailwindTextField
                          label="Bank Account No / IBAN"
                          name="BankAccountNo"
                          id="BankAccountNo"
                          variant="outlined"
                          fullWidth
                          disabled={!isEmploymentEditing}
                          // type="number"
                          className="inpBackColor"
                          value={formik.values.BankAccountNo}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <AccountBalanceWalletIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Department Select */}
                        {/* <div className="flex items-center">
                          <FormControl
                            variant="outlined"
                            fullWidth
                            disabled={!isEmploymentEditing}
                          >
                            <InputLabel id="department-label">
                              Branch
                            </InputLabel>
                            <Select
                              labelId="department-label"
                              name="Department"
                              value={formik.values.Department}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              startAdornment={
                                <InputAdornment position="start">
                                  <ApartmentIcon />
                                </InputAdornment>
                              }
                              label="Branch"
                            >
                              {departmentLisFromAPI?.map((item, index) => (
                                <MenuItem key={index} value={item.Description}>
                                  {item.Description}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <IconButton
                            onClick={() =>
                              setShowBranchCreationEditPopup((prev) => !prev)
                            }
                            disabled={!isEmploymentEditing} // Add this to disable the button based on a condition
                            sx={{
                              backgroundColor: !isEmploymentEditing
                                ? "#d1d5db"
                                : "#f7f7f7", // Gray when disabled, original color when enabled
                              marginLeft: 1,
                              width: "50px",
                              height: "50px",
                              "&:hover": {
                                backgroundColor: !isEmploymentEditing
                                  ? "#d1d5db"
                                  : "#e5e7eb", // Consistent hover effect
                              },
                              "&.Mui-disabled": {
                                cursor: "not-allowed", // Indicate non-interactive state
                                opacity: 0.6, // Material-UI default disabled opacity
                              },
                            }}
                          >
                            <EditAttributesIcon />
                          </IconButton>
                        </div> */}
                      </div>
                    </CardContent>
                  </Card>
                </div>
                {/* Documents //////////////// */}
                <div className="space-y-4">
                  <Card className="rounded-2xl border border-slate-200 shadow-sm">
                    <CardContent className="relative">
                      <div className="absolute top-4 right-4">
                        <IconButton
                          onClick={() => setIsDocumentsEditing((prev) => !prev)}
                        >
                          <EditIcon />
                        </IconButton>
                      </div>
                      {/* <h2 className="text-xl font-semibold text-slate-600 flex items-center justify-start mb-4 gap-2">
                        <PassportIcon className="text-[#757575]" /> Documents
                      </h2> */}
                      <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                        <PassportIcon className="text-blue-600" /> DOCUMENTS
                      </h2>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-7 text-sm text-slate-600">
                        {/* </div> */}
                        {/* </CardContent>
                        </Card> */}

                        {/* Other Details */}

                        {/*<Card className="rounded-2xl border border-slate-200 shadow-sm">
                          <CardContent className="relative">
                            <div className="absolute top-4 right-4">
                               <IconButton onClick={() => setIsEditing((prev) => !prev)}>
                      <EditIcon />
                    </IconButton> 
                            </div>
                            <h2 className="text-xl font-semibold text-slate-600 flex items-center justify-start mb-4 gap-2">
                              <BadgeIcon className="text-[#757575]" /> Other Details
                            </h2>*/}

                        {/* <div className="grid grid-cols-1 sm:grid-cols-2  gap-6 text-sm text-slate-600"> */}
                        <TailwindTextField
                          label="Emirates ID"
                          name="EmiratesId"
                          id="EmiratesId"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.EmiratesId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          error={
                            formik.touched.EmiratesId &&
                            Boolean(formik.errors.EmiratesId)
                          }
                          helperText={
                            formik.touched.EmiratesId &&
                            formik.errors.EmiratesId
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <BadgeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* <TailwindTextField
                          label="Emirates ID Expiry"
                          name="EmiratesIdExpiryDate"
                          id="EmiratesIdExpiryDate"
                          type="text"
                          onFocus={(e) => (e.target.type = "date")}
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          // value={formik.values.EmiratesIdExpiryDate}
                          value={formik.values.EmiratesIdExpiryDate &&
                            new Date(formik.values.EmiratesIdExpiryDate).toLocaleDateString("en-GB")}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CalendarMonthIcon />
                              </InputAdornment>
                            ),
                          }}
                        /> */}

                        {/* <TailwindTextField
                          label="Emirates ID Expiry"
                          name="EmiratesIdExpiryDate"
                          id="EmiratesIdExpiryDate"
                          type="date"
                          // onFocus={(e) => (e.target.type = "date")}
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={
                            formik.values.EmiratesIdExpiryDate
                              ? dayjs(
                                  formik.values.EmiratesIdExpiryDate
                                ).format("DD-MMM-YYYY ")
                              : ""
                          }


                          // value={
                          //   formik.values.EmiratesIdExpiryDate || ""
                          // }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          InputLabelProps={{ shrink: true }} 
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CalendarMonthIcon />
                              </InputAdornment>
                            ),
                          }}
                        /> */}

                        {/* <TailwindTextField
                          label="Emirates ID Expiry"
                          name="EmiratesIdExpiryDate"
                          id="EmiratesIdExpiryDate"
                          type="date"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.EmiratesIdExpiryDate || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          InputLabelProps={{ shrink: true }} // ensures label floats for type=date
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CalendarMonthIcon />
                              </InputAdornment>
                            ),
                          }}
                        /> */}

                        <TailwindTextField
                          id="EmiratesIdExpiryDate"
                          label="Emirates ID Expiry"
                          name="EmiratesIdExpiryDate"
                          // type="text"
                          type="date"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          InputLabelProps={{ shrink: true }}
                          placeholder="DD-MMM-YYYY"
                          // value={
                          //   formik.values.EmiratesIdExpiryDate
                          //     ? dayjs(
                          //         formik.values.EmiratesIdExpiryDate,
                          //       ).format("DD-MMM-YYYY ")
                          //     : ""
                          // }
                          value={
                            formik.values.EmiratesIdExpiryDate?.substring(
                              0,
                              10,
                            ) || ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <CalendarMonthIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                        />

                        <TailwindTextField
                          label="Insurance No"
                          name="InsuranceNo"
                          id="InsuranceNo"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.InsuranceNo}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <ContactEmergencyIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        <TailwindTextField
                          label="Insurance Expiry"
                          name="InsuranceExpiryDate"
                          id="InsuranceExpiryDate"
                          // type="text"
                          type="date"
                          onFocus={(e) => (e.target.type = "date")}
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          // value={
                          //   formik.values.InsuranceExpiryDate
                          //     ? dayjs(formik.values.InsuranceExpiryDate).format(
                          //         "DD-MMM-YYYY ",
                          //       )
                          //     : ""
                          // }
                          value={
                            formik.values.InsuranceExpiryDate?.substring(
                              0,
                              10,
                            ) || ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <CalendarMonthIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                        />

                        <TailwindTextField
                          label="Driving Licence No"
                          name="DrivingLicenceNo"
                          id="DrivingLicenceNo"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.DrivingLicenceNo}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CreditCardIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* <TailwindTextField
                          label="Licence Expiry Date"
                          name="DrivingLicenceExpiryDate"
                          id="DrivingLicenceExpiryDate"
                          type="text"
                          onFocus={(e) => (e.target.type = "date")}
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          // value={formik.values.DrivingLicenceExpiryDate}
                          value={
                            formik.values.DrivingLicenceExpiryDate ?
                            new Date(
                              formik.values.DrivingLicenceExpiryDate
                            ).toISOString().split("T")[0] :  ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CalendarMonthIcon />
                              </InputAdornment>
                            ),
                          }}
                        /> */}

                        <TailwindTextField
                          label="Licence Expiry Date"
                          name="DrivingLicenceExpiryDate"
                          id="DrivingLicenceExpiryDate"
                          // type="text"
                          type="date"
                          onFocus={(e) => (e.target.type = "date")}
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          // value={
                          //   formik.values.DrivingLicenceExpiryDate
                          //     ? dayjs(
                          //         formik.values.DrivingLicenceExpiryDate,
                          //       ).format("DD-MMM-YYYY ")
                          //     : ""
                          // }
                          value={
                            formik.values.DrivingLicenceExpiryDate?.substring(
                              0,
                              10,
                            ) || ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <CalendarMonthIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                        />

                        <TailwindTextField
                          label="Visa No"
                          name="VisaNo"
                          id="VisaNo"
                          type="number"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.VisaNo}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <VisaIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        <TailwindTextField
                          label="Visa Expiry"
                          name="VisaExpiryDate"
                          id="VisaExpiryDate"
                          // type="text"
                          type="date"
                          onFocus={(e) => (e.target.type = "date")}
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          // value={formik.values.VisaExpiryDate}
                          // value={
                          //   formik.values.VisaExpiryDate
                          //     ? new Date(formik.values.VisaExpiryDate)
                          //         .toISOString()
                          //         .split("T")[0]
                          //     : ""
                          // }
                          // value={
                          //   formik.values.VisaExpiryDate
                          //     ? dayjs(formik.values.VisaExpiryDate).format(
                          //         "DD-MMM-YYYY ",
                          //       )
                          //     : ""
                          // }
                          value={
                            formik.values.VisaExpiryDate?.substring(0, 10) || ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <CalendarMonthIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                        />

                        <TailwindTextField
                          // label="Person ID"
                          label="Labour Card"
                          name="PersonId"
                          id="PersonId"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.PersonId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        <TailwindTextField
                          // label="Person ID Expiry"
                          label="Labour Card Expiry"
                          name="PersonIdExpiryDate"
                          id="PersonIdExpiryDate"
                          // type="text"
                          type="date"
                          onFocus={(e) => (e.target.type = "date")}
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          // value={formik.values.PersonIdExpiryDate}
                          // value={
                          //   formik.values.PersonIdExpiryDate
                          //     ? new Date(formik.values.PersonIdExpiryDate)
                          //         .toISOString()
                          //         .split("T")[0]
                          //     : ""
                          // }
                          // value={
                          //   formik.values.PersonIdExpiryDate
                          //     ? dayjs(formik.values.PersonIdExpiryDate).format(
                          //         "DD-MMM-YYYY ",
                          //       )
                          //     : ""
                          // }
                          value={
                            formik.values.PersonIdExpiryDate?.substring(
                              0,
                              10,
                            ) || ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <CalendarMonthIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                        />

                        <TailwindTextField
                          label="Part-time Labour No"
                          name="PartTimeLabour"
                          id="PartTimeLabour"
                          type="number"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.PartTimeLabour}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={!isEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EngineeringIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        <TailwindTextField
                          label="Part-time Labour Expiry"
                          name="PartTimeLabourExpiryDate"
                          id="PartTimeLabourExpiryDate"
                          // type="text"
                          type="date"
                          onFocus={(e) => (e.target.type = "date")}
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          // value={
                          //   formik.values.PartTimeLabourExpiryDate
                          //     ? dayjs(
                          //         formik.values.PartTimeLabourExpiryDate,
                          //       ).format("DD-MMM-YYYY")
                          //     : ""
                          // }
                          value={
                            formik.values.PartTimeLabourExpiryDate?.substring(
                              0,
                              10,
                            ) || ""
                          }
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            const formattedDateTime = `${selectedDate}T00:00:00`;
                            formik.setFieldValue(
                              "PartTimeLabourExpiryDate",
                              formattedDateTime,
                            );
                          }}
                          onBlur={formik.handleBlur}
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <CalendarMonthIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                        />

                        {/* Passport No */}
                        <TailwindTextField
                          label="Passport No"
                          className="inpBackColor"
                          name="PassportNo"
                          id="PassportNo"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.PassportNo}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.PassportNo &&
                            Boolean(formik.errors.PassportNo)
                          }
                          helperText={
                            formik.touched.PassportNo &&
                            formik.errors.PassportNo
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PassportIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        <TailwindTextField
                          label="Passport Expiry Date"
                          className="inpBackColor"
                          name="PassportExpiryDate"
                          id="PassportExpiryDate"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          // value={
                          //   formik.values.PassportExpiryDate
                          //     ? new Date(formik.values.PassportExpiryDate)
                          //         .toISOString()
                          //         .split("T")[0]
                          //     : ""
                          // }
                          // value={
                          //   formik.values.PassportExpiryDate
                          //     ? dayjs(formik.values.PassportExpiryDate).format(
                          //         "DD-MMM-YYYY",
                          //       )
                          //     : ""
                          // }
                          value={
                            formik.values.PassportExpiryDate?.substring(
                              0,
                              10,
                            ) || ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.PassportExpiryDate &&
                            Boolean(formik.errors.PassportExpiryDate)
                          }
                          helperText={
                            formik.touched.PassportExpiryDate &&
                            formik.errors.PassportExpiryDate
                          }
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       {/* <EventIcon /> */}
                          //       <CalendarMonthIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                          onFocus={(e) => (e.target.type = "date")}
                        />

                        {/* Passport Place of Issue */}
                        <TailwindTextField
                          label="Passport Place of Issue"
                          className="inpBackColor"
                          name="PassportPlaceofIssue"
                          id="PassportPlaceofIssue"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.PassportPlaceofIssue}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.PassportPlaceofIssue &&
                            Boolean(formik.errors.PassportPlaceofIssue)
                          }
                          helperText={
                            formik.touched.PassportPlaceofIssue &&
                            formik.errors.PassportPlaceofIssue
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PlaceIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Passport Country of Issue */}
                        <TailwindTextField
                          label="Passport Country of Issue"
                          className="inpBackColor"
                          name="PassportCountryofIssue"
                          id="PassportCountryofIssue"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          value={formik.values.PassportCountryofIssue}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.PassportCountryofIssue &&
                            Boolean(formik.errors.PassportCountryofIssue)
                          }
                          helperText={
                            formik.touched.PassportCountryofIssue &&
                            formik.errors.PassportCountryofIssue
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CountryIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Passport Issue Date */}
                        <TailwindTextField
                          label="Passport Issue Date"
                          className="inpBackColor"
                          name="PassportIssueDate"
                          id="PassportIssueDate"
                          variant="outlined"
                          fullWidth
                          disabled={!isDocumentsEditing}
                          // value={formik.values.PassportIssueDate}
                          // value={
                          //   formik.values.PassportIssueDate
                          //     ? new Date(formik.values.PassportIssueDate)
                          //         .toISOString()
                          //         .split("T")[0]
                          //     : ""
                          // }
                          // value={
                          //   formik.values.PassportIssueDate
                          //     ? dayjs(formik.values.PassportIssueDate).format(
                          //         "DD-MMM-YYYY ",
                          //       )
                          //     : ""
                          // }
                          value={
                            formik.values.PassportIssueDate?.substring(0, 10) ||
                            ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          onFocus={(e) => (e.target.type = "date")}
                          onBlurCapture={(e) => {
                            if (!formik.values.PassportIssueDate)
                              e.target.type = "text";
                          }}
                          error={
                            formik.touched.PassportIssueDate &&
                            Boolean(formik.errors.PassportIssueDate)
                          }
                          helperText={
                            formik.touched.PassportIssueDate &&
                            formik.errors.PassportIssueDate
                          }
                          // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       {/* <EventIcon /> */}
                          //       <CalendarMonthIcon />
                          //     </InputAdornment>
                          //   ),
                          // }}
                        />

                        {/* Passport Image Upload */}
                        {/* <FormControl
                          fullWidth
                          disabled={!isDocumentsEditing}
                          className="inpBackColor "
                        >
                          <FormLabel
                            htmlFor="photo"
                            className="text-slate-600 text-[10px] flex items-center gap-2"
                          >
                            <ImageIcon />
                            <span className="text-slate-600 text-[12px]">
                              Document Attachment
                            </span>
                          </FormLabel>
                          <Input
                            id="photo"
                            name="photo"
                            type="file"
                            onChange={(event) =>
                              formik.setFieldValue(
                                "photo",
                                event.currentTarget.files[0]
                              )
                            }
                            onBlur={formik.handleBlur}
                            disableUnderline
                            inputProps={{ accept: "image/*" }}
                          />
                          {formik.touched.photo && formik.errors.photo && (
                            <FormHelperText error>
                              {formik.errors.photo}
                            </FormHelperText>
                          )}
                        </FormControl> */}
                      </div>
                    </CardContent>
                  </Card>
                  {/* ///// GPS//// */}

                  <Card className="my-4 rounded-2xl border border-slate-200 shadow-sm">
                    <CardContent className="relative">
                      {/* <Typography
                variant="h6"
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <GpsFixedIcon style={{ marginRight: "8px" }} />
                GPS Coordinates
                </Typography> */}

                      {/* <h2 className="text-xl font-semibold text-slate-600 flex items-center justify-start mb-4 gap-2">
                        <GpsFixedIcon className="text-[#757575]" /> GPS
                        Coordinates
                      </h2> */}
                      <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                        <GpsFixedIcon className="text-blue-600" /> GPS
                        COORDINATES
                      </h2>
                      <div className="absolute top-4 right-4">
                        <IconButton
                          onClick={() => setIsGPSEditing((prev) => !prev)}
                        >
                          <EditIcon />
                        </IconButton>
                      </div>

                      <div style={{ marginBottom: "16px" }}>
                        <TailwindTextField
                          variant="outlined"
                          label="Latitude"
                          type="text"
                          // class="form-control inpBackColor"
                          id="Latitude"
                          name="Latitude"
                          onChange={formik.handleChange("Latitude")}
                          onBlur={formik.handleBlur("Latitude")}
                          value={formik.values.Latitude}
                          fullWidth
                          disabled={!isGPSEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <MyLocationIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>

                      <div
                        style={{
                          marginBottom: "16px",
                          paddingBottom: "16px",
                        }}
                      >
                        <TailwindTextField
                          variant="outlined"
                          label="Longitude"
                          type="text"
                          name="Longitude"
                          onChange={formik.handleChange("Longitude")}
                          onBlur={formik.handleBlur("Longitude")}
                          value={formik.values.Longitude}
                          fullWidth
                          disabled={!isGPSEditing}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PublicIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>

                      {/* <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingBottom: "19px",
                          opacity: !isGPSEditing ? 0.5 : 1, // 🔒 visually indicate it's disabled
                          pointerEvents: !isGPSEditing ? "none" : "auto", // 🚫 block all interactions if disabled
                        }}
                      >
                        {/* <RoomIcon style={{ marginRight: "8px" }} /> 
                        <LocationOnIcon className="mr-2 text-[#757575]" />
                        <Typography
                          variant="body1"
                          style={{ marginRight: "8px" }}
                        >
                          Activate Geofencing
                        </Typography>
                        <Switch
                          checked={formik.values.Geofencing || false}
                          onChange={(e) =>
                            formik.setFieldValue("Geofencing", e.target.checked)
                          }
                          name="Geofencing"
                          disabled={!isGPSEditing} // ✅ switch disabled if either condition is true
                        />
                      </div> */}

                      {/* <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingBottom: "19px",
                            opacity: !isPersonalEditing ? 0.5 : 1, // 🔒 visually indicate it's disabled
                            pointerEvents: !isPersonalEditing ? "none" : "auto", // 🚫 block all interactions if disabled
                          }}
                        > */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingBottom: "19px",
                          opacity: !isGPSEditing ? 0.5 : 1, // 🔒 visually indicate it's disabled
                          pointerEvents: !isGPSEditing ? "none" : "auto", // 🚫 block all interactions if disabled
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              checked={formik.values.onlineallow === "T"}
                              onChange={(e) =>
                                formik.setFieldValue(
                                  "onlineallow",
                                  e.target.checked ? "T" : "",
                                )
                              }
                              name="onlineallow"
                              disabled={!isGPSEditing}
                              color="primary"
                            />
                          }
                          // label="Office Check-in Mandatory"
                          label="Activate GeoFencing"
                        />
                        {formik.touched.onlineallow &&
                          formik.errors.onlineallow && (
                            <div className="text-red-500 text-sm mt-1">
                              {formik.errors.onlineallow}
                            </div>
                          )}
                      </div>
                    </CardContent>
                  </Card>
                  {/* </div> */}
                </div>
                {/* Documents //////////////// */}
                <div className="lg:col-span-3">
                  {/* <Card className="rounded-2xl border border-slate-200 shadow-sm">
                    <CardContent> */}
                  <Box className="relative mb-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                    <div className="absolute top-4 right-4">
                      <IconButton
                        onClick={() => setIsSalaryEditing((prev) => !prev)}
                      >
                        <EditIcon />
                      </IconButton>
                    </div>
                    {/* <Typography
                          variant="h6"
                          className="flex items-center gap-2 mb-4 font-semibold"
                        >
                          <TbEPassport />
                          Payroll Values
                        </Typography> */}

                    {/* <h2 className="text-xl font-semibold text-slate-600 flex items-center gap-2">
                      <TbEPassport className="text-[#757575]" />
                      Payroll Values
                    </h2> */}

                    <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 ">
                      <IconButton>
                        <EditIcon className="text-blue-600" />
                      </IconButton>{" "}
                      PAYROL VALUES , SALARY INFORMATION
                    </h2>

                    {/* Salary Info */}
                    <Typography
                      variant="subtitle1"
                      className="flex items-center gap-2 mb-4 font-semibold text-[#757575]"
                    >
                      <MdContactEmergency />
                      Salary Information
                    </Typography>
                    <div className="absolute top-4 right-4">
                      <IconButton
                        onClick={() => setIsSalaryEditing((prev) => !prev)}
                      >
                        <EditIcon />
                      </IconButton>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      {/* Column 1 */}
                      <Box>
                        <TailwindTextField
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Input Basic Pay Here"
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            setbasicPay(parseInt(e.target.value))
                          }
                        />
                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Initial Basic Pay"
                          type="number"
                          variant="outlined"
                          value={formik.values.BasicPay}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          name="BasicPay"
                          // disabled
                        />
                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Increments Total"
                          type="number"
                          variant="outlined"
                          name="Allowances_NOT"
                          value={IncTotal}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled
                        />
                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Net Basic Salary"
                          type="number"
                          variant="outlined"
                          name="NetBasicSalary"
                          // value={
                          //   basicPay + IncTotal
                          //     ? basicPay + IncTotal
                          //     : empState?.BasicPay + IncTotal || ""
                          // }
                          value={
                            formik.values.BasicPay + IncTotal
                              ? formik.values.BasicPay + IncTotal
                              : formik.values.BasicPay + IncTotal || ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled
                        />
                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Allowances"
                          type="number"
                          variant="outlined"
                          name="Allowances_OT"
                          value={AlvTotal || allowanceAmountSum}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled
                        />
                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Net Salary"
                          type="number"
                          variant="outlined"
                          name="NetSalary"
                          // value={formik.values.NetSalary}
                          //                           value={
                          //   basicPay + IncTotal
                          //     ? basicPay + IncTotal + AlvTotal
                          //     : empState?.BasicPay + IncTotal + AlvTotal|| ""
                          // }
                          value={
                            formik.values.BasicPay + IncTotal + AlvTotal ||
                            formik.values.BasicPay +
                              incrementAmountSum +
                              allowanceAmountSum ||
                            ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled
                        />
                      </Box>

                      {/* Column 2 */}
                      <Box>
                        <FormControl
                          variant="outlined"
                          fullWidth
                          disabled={!isSalaryEditing}
                        >
                          <InputLabel>Time Sheet Category</InputLabel>
                          <Select
                            defaultValue=""
                            onChange={handleAddrTypeChange}
                          >
                            <MenuItem value="">
                              <em>Select Category</em>
                            </MenuItem>
                            <MenuItem value="1">Calendar Days</MenuItem>
                            <MenuItem value="2">Hourly Wage</MenuItem>
                          </Select>
                        </FormControl>

                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Normal Hrs"
                          type="number"
                          variant="outlined"
                          name="NormalHrs"
                          value={formik.values.NormalHrs}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // disabled={formik.values.NormalHrs !== undefined}
                        />

                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Hourly Wage"
                          type="text"
                          variant="outlined"
                          name="HourlyWage"
                          value={formik.values.HourlyWage}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="0.00"
                          // disabled={Category !== "2"}
                        />

                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="OT Rate"
                          type="text"
                          variant="outlined"
                          name="OTrate"
                          value={formik.values.OTrate}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />

                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Special OT Rate"
                          type="text"
                          variant="outlined"
                          name="SplOtRate"
                          value={formik.values.SplOtRate}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />

                        <TailwindTextField
                          disabled={!isSalaryEditing}
                          className="mt-4"
                          variant="outlined"
                          // label="Regular Time"
                          // type="time"
                          label="Regular Date & Time"
                          type="datetime-local"
                          name="regularTime"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.regularTime}
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <AccessTimeIcon className="mr-2 text-[#757575]" />
                            ),
                          }}
                        />
                      </Box>

                      {/* Column 3 */}
                      <div className="rounded-2xl border border-slate-200 bg-slate-50/60 p-4">
                        {/* <Typography
                          variant="subtitle1"
                          className=" text-[#757575] flex items-center gap-2 mb-4 font-semibold"
                        >
                          <MdContactEmergency />
                          Account Setting
                        </Typography> */}

                        <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                          <ManageAccountsIcon className="text-blue-600" />{" "}
                          ACCOUNT SETTING
                        </h2>

                        <TailwindTextField
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Salary Payable"
                          type="text"
                          variant="outlined"
                          name="SalaryAc"
                          value={formik.values.SalaryAc || ""}
                          // value={
                          //   SalaryPayment
                          //     ? SalaryPayment
                          //     : formik.values.SalaryAc || ""
                          // }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <IconButton
                                className="ml-2"
                                data-bs-toggle="modal"
                                data-bs-target="#salaryPayableModal"
                              >
                                <MdMenuOpen />
                              </IconButton>
                            ),
                          }}
                        />
                        {/* <SalaryPayablePopup SalaryPayable={SalaryPayable} /> */}
                        <SalaryPayablePopup
                          modalId="salaryPayableModal"
                          onSelectAccount={handleAccountSelect}
                        />

                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Salary Expense"
                          type="text"
                          variant="outlined"
                          name="AdvanceAc"
                          value={formik.values.AdvanceAc}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <IconButton
                                className="ml-2"
                                data-bs-toggle="modal"
                                data-bs-target="#salaryExpenseModal"
                              >
                                <MdMenuOpen />
                              </IconButton>
                            ),
                          }}
                        />
                        <SalaryPayablePopup
                          modalId="salaryExpenseModal"
                          onSelectAccount={handleSalaryExpenseSelect}
                        />

                        <TailwindTextField
                          className="mt-4"
                          fullWidth
                          disabled={!isSalaryEditing}
                          label="Loans & Advances"
                          type="text"
                          variant="outlined"
                          name="Notes"
                          value={formik.values.Notes}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <IconButton
                                className="ml-2"
                                data-bs-toggle="modal"
                                data-bs-target="#loansAdvancesModal"
                              >
                                <MdMenuOpen />
                              </IconButton>
                            ),
                          }}
                        />
                        <SalaryPayablePopup
                          modalId="loansAdvancesModal"
                          onSelectAccount={handleLoansAdvancesSelect}
                        />
                      </div>
                    </div>

                    {/* ///////////////////////////////////////////////////////////////////// */}

                    {/* ///////////////////////////////////////////////////////////////////// */}

                    {/* Allowance Details */}
                    {/* <div className="mt-6">
                      
                      <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                        <PaymentsIcon className="text-blue-600" /> ALLOWANCE
                        CREATION
                      </h2>
                      <CreateAllowance
                        calculationAlv={calculationAlv}
                        EmpIdTop={empState?.EmpId}
                        onValuesChange={handleAllowanceValuesChange}
                      />

                      <div className="mt-4 max-h-60 overflow-auto rounded-xl border border-slate-200">
                        <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                          <PaymentsIcon className="text-blue-600" /> ALLOWANCE
                          LIST
                        </h2>
                        <table className="min-w-full border border-slate-200 shadow-sm overflow-hidden rounded-xl ">
                          <thead className="sticky top-0 bg-slate-100 text-xs uppercase tracking-wide text-slate-600">
                            <tr>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Sl No
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Description
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Amount
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Date
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Reason
                              </th>
                            </tr>
                          </thead>

                          <tbody className="text-sm text-slate-600">
                            {AllowanceData?.length ? (
                              AllowanceData.map((d, i) => (
                                <tr
                                  key={i}
                                  className="border-t border-slate-200 transition-colors hover:bg-slate-50"
                                >
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {i + 1}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {d.AllowanceType}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {d.Amount}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {dayjs(d.ADate).format("DD-MMM-YYYY")}
                                  </td>
                                  <td className="px-4 py-3">
                                    {d.AffectOTCalc}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="5"
                                  className="px-4 py-6 text-center text-sm text-slate-500"
                                >
                                  No allowances recorded.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div> */}

                    {/* Increment Details */}
                    {/* <div className="mt-6">
                     
                      <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                        <TrendingUpIcon className="text-blue-600" /> INCREMENT
                        CREATION
                      </h2>
                      <CreateIncrement
                        calculationInc={calculationInc}
                        EmpIdTop={empState?.EmpId}
                        onValuesChange={handleIncrementValuesChange}
                      />
                      <CreateIncrementPopup />

                      <div className="max-h-60 overflow-x-auto mt-4">
                        <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                          <TrendingUpIcon className="text-blue-600" /> INCREMENT
                          LIST
                        </h2>
                        <table className="min-w-full border border-slate-200 shadow-sm overflow-hidden rounded-xl ">
                         
                          <thead className="sticky top-0 bg-slate-100 text-xs uppercase tracking-wide text-slate-600">
                            <tr>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Sl No
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Description
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Amount
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Date
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Reason
                              </th>
                            </tr>
                          </thead>

                  
                          <tbody className="text-sm text-slate-600">
                            {IncrementData?.length ? (
                              IncrementData.map((d, i) => (
                                <tr
                                  key={i}
                                  className="border-t border-slate-200 transition-colors hover:bg-slate-50"
                                >
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {i + 1}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {d.AllowanceType}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {d.Amount}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {dayjs(d.ADate).format("DD-MMM-YYYY ")}
                                  </td>
                                  <td className="px-4 py-3">
                                    {d.AffectOTCalc}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="5"
                                  className="px-4 py-6 text-center text-sm text-slate-500"
                                >
                                  No increments recorded.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>*/}
                  </Box>
                  {/* </CardContent>
                  </Card> */}

                  <Box
                    className="mt-4 mb-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
                    sx={{
                      opacity: isLeaveDisabled ? 0.5 : 1,
                      pointerEvents: isLeaveDisabled ? "none" : "auto",
                    }}
                  >
                    {/* ///////////////////////////////////////////////////////////////////// */}

                    <Accordion
                      expanded={isPayrollExpanded}
                      onChange={(_, expanded) => setIsPayrollExpanded(expanded)}
                      disableGutters
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 gap-2">
                          <PaymentsIcon className="text-blue-600" />
                          ALLOWANCES & INCREMENTS
                        </h2>
                      </AccordionSummary>

                      <AccordionDetails>
                        {isPayrollLoading ? (
                          <div className="px-4 py-6 text-center text-sm text-slate-500">
                            Loading payroll...
                          </div>
                        ) : (
                          <>
                            <CreateAllowance
                              calculationAlv={calculationAlv}
                              EmpIdTop={empState?.EmpId}
                              onValuesChange={handleAllowanceValuesChange}
                            />

                            <div className="mt-4 max-h-60 overflow-auto rounded-xl border border-slate-200">
                              <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                                <PaymentsIcon className="text-blue-600" />{" "}
                                ALLOWANCE LIST
                              </h2>

                              <table className="min-w-full border border-slate-200 shadow-sm overflow-hidden rounded-xl">
                                <thead className="sticky top-0 bg-slate-100 text-xs uppercase tracking-wide text-slate-600">
                                  <tr>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Sl No
                                    </th>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Description
                                    </th>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Amount
                                    </th>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Date
                                    </th>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Reason
                                    </th>
                                  </tr>
                                </thead>

                                <tbody className="text-sm text-slate-600">
                                  {AllowanceData?.length ? (
                                    AllowanceData.map((d, i) => (
                                      <tr
                                        key={d.TranId || i}
                                        className="border-t border-slate-200 hover:bg-slate-50"
                                      >
                                        <td className="whitespace-nowrap px-4 py-3">
                                          {i + 1}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3">
                                          {d.AllowanceType}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3">
                                          {d.Amount}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3">
                                          {dayjs(d.ADate).format("DD-MMM-YYYY")}
                                        </td>
                                        <td className="px-4 py-3">
                                          {d.AffectOTCalc}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan="5"
                                        className="px-4 py-6 text-center text-sm text-slate-500"
                                      >
                                        No allowances recorded.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>

                            <CreateIncrement
                              calculationInc={calculationInc}
                              EmpIdTop={empState?.EmpId}
                              onValuesChange={handleIncrementValuesChange}
                            />

                            <div className="max-h-60 overflow-x-auto mt-4">
                              <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                                <TrendingUpIcon className="text-blue-600" />{" "}
                                INCREMENT LIST
                              </h2>

                              <table className="min-w-full border border-slate-200 shadow-sm overflow-hidden rounded-xl">
                                <thead className="sticky top-0 bg-slate-100 text-xs uppercase tracking-wide text-slate-600">
                                  <tr>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Sl No
                                    </th>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Description
                                    </th>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Amount
                                    </th>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Date
                                    </th>
                                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                      Reason
                                    </th>
                                  </tr>
                                </thead>

                                <tbody className="text-sm text-slate-600">
                                  {IncrementData?.length ? (
                                    IncrementData.map((d, i) => (
                                      <tr
                                        key={d.TranId || i}
                                        className="border-t border-slate-200 hover:bg-slate-50"
                                      >
                                        <td className="whitespace-nowrap px-4 py-3">
                                          {i + 1}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3">
                                          {d.AllowanceType}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3">
                                          {d.Amount}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3">
                                          {dayjs(d.ADate).format("DD-MMM-YYYY")}
                                        </td>
                                        <td className="px-4 py-3">
                                          {d.AffectOTCalc}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan="5"
                                        className="px-4 py-6 text-center text-sm text-slate-500"
                                      >
                                        No increments recorded.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </>
                        )}
                      </AccordionDetails>
                    </Accordion>

                    {/* ///////////////////////////////////////////////////////////////////// */}
                  </Box>
                  <Box
                    className="mt-4 mb-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
                    sx={{
                      opacity: isLeaveDisabled ? 0.5 : 1,
                      pointerEvents: isLeaveDisabled ? "none" : "auto",
                    }}
                  >
                    {/* Header Row */}
                    <Box className="flex flex-col md:flex-row justify-between items-start md:items-center">
                      {/* <h2 className="text-xl font-semibold text-slate-600 flex items-center gap-2">
                        <GiThreeLeaves className="text-[#757575]" />
                        Leave Information
                      </h2> */}
                      <h2 className="flex items-center text-sm font-semibold uppercase tracking-wide text-blue-600 justify-start mb-4 gap-2">
                        <CalendarMonthIcon className="text-blue-600" /> LEAVE
                        INFORMATION
                      </h2>

                      {/* <IconButton
                        onClick={() => setIsLeaveDisabled((prev) => !prev)}
                      >
                        <EditIcon />
                      </IconButton> */}
                    </Box>

                    {/* Current Leave Status */}
                    {/* <Typography
                      variant="subtitle1"
                      className="flex items-center gap-2 mt-6 mb-2 font-semibold"
                    >
                      <IoDocumentsOutline />
                      Current Leave Status
                    </Typography>

                    <TableContainer
                      component={Paper}
                      className="overflow-x-auto mb-4"
                    >
                      <Table size="small" aria-label="leave status">
                        <TableHead className="bg-slate-100">
                          <TableRow>
                            <TableCell className="font-semibold text-slate-900">
                              Leave Category
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Alloted
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Consumed
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Balance
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {leaveStatusData && leaveStatusData.map((item,index)=>(

                            <TableRow
                            hover
                            className="transition-colors duration-200"
                            >
                            <TableCell>{item.LEAVECATEGORY}</TableCell>
                            <TableCell>{item.ALLOTED}</TableCell>
                            <TableCell>{item.CONSUMED}</TableCell>
                            <TableCell>{item.Balance}</TableCell>
                          </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer> */}

                    <div className="mb-6">
                      <h3 className="text-sm font-semibold text-slate-800 mb-2 flex items-center gap-2">
                        <IoTime className="text-blue-600" />
                        <span className="text-blue-600">
                          {" "}
                          Current Leave Status{" "}
                        </span>
                      </h3>

                      <div className="overflow-x-auto rounded-xl border border-slate-200">
                        <table className="min-w-full overflow-hidden rounded-xl border border-slate-200 text-sm text-slate-600 shadow-sm">
                          <thead className="sticky top-0 bg-slate-100 text-xs uppercase tracking-wide text-slate-600">
                            <tr>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Leave Category
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Allotted
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Consumed
                              </th>
                              <th className="whitespace-nowrap px-4 py-3 text-left font-semibold">
                                Balance
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {leaveStatusData?.length ? (
                              leaveStatusData.map((item, index) => (
                                <tr className="border-t border-slate-200 bg-white transition-colors hover:bg-slate-50">
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {item.LEAVECATEGORY}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {item.ALLOTED}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {item.CONSUMED}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-3">
                                    {item.Balance}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="4"
                                  className="px-4 py-6 text-center text-sm text-slate-500"
                                >
                                  No leave status available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* Leave History */}
                    {/* <Typography
                      variant="subtitle1"
                      className="flex items-center gap-2 mt-8 mb-2 font-semibold"
                    >
                      <IoDocumentsOutline />
                      Leave History of Employee
                    </Typography>

                    <TableContainer
                      component={Paper}
                      className="overflow-x-auto"
                    >
                      <Table size="small" aria-label="leave history">
                        <TableHead className="bg-slate-100">
                          <TableRow>
                            <TableCell className="font-semibold text-slate-900">
                              Leave Category
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              From Dt
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              To Dt
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Appr Dt
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Leaves
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Rejoin Dt
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Status
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Notes
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Ticket
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Apprvd By
                            </TableCell>
                            <TableCell className="font-semibold text-slate-900">
                              Next Expiry Leave
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {leaveHistoryData && leaveHistoryData.map((item,index)=>(
                            
                         
                          ))}

                        </TableBody>
                      </Table>
                    </TableContainer> */}
                  </Box>
                </div>
                {/* </div> */}
              </div>
            </div>

            <div className="online-switch personal">
              <div className="container"></div>
            </div>

            <div className="flex items-center justify-center mb-4 ">
              {/* <button className="dash-btn my-3" type="submit"> */}
              {/* <button
                className="bg-blue-600 px-4 py-2 rounded text-white hover:bg-blue-600 w-40 my-3 flex justify-center items-center gap-2"
                type="submit"
              >
                <MdAddChart />
                {showSubmitLoader ? (
                  <Oval
                    visible={true}
                    height="12"
                    width="12"
                    color="white"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperclassName=""
                  />
                ) : (
                  "Submit"
                )}
              </button> */}

              <div className="flex justify-center items-center">
                {/* <button
                        type="submit"
                        className="bg-teal-600 text-white w-[300px] px-4 py-2 rounded-xl hover:bg-teal-700"
                        disabled={showSubmitLoader}
                      >
                        {showSubmitLoader ? "Submitting..." : "Submit"}
                      </button> */}
                <button
                  type="submit"
                  disabled={showSubmitLoader}
                  className={`
                  relative
                  w-[300px]
                  px-6 py-2.5
                  rounded-xl
                  font-semibold
                  text-white
                  transition-all duration-200
                  shadow-sm
                  flex items-center justify-center gap-2
                  ${
                    showSubmitLoader
                      ? "bg-emerald-400 cursor-not-allowed"
                      : "bg-emerald-600 hover:bg-emerald-700 active:scale-95"
                  }
                `}
                >
                  {showSubmitLoader && (
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  )}

                  {showSubmitLoader ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
            {/* </div> */}
          </form>
          <SnackbarNotification
            open={snackbar.open}
            severity={snackbar.severity}
            message={snackbar.message}
            onClose={handleClose}
          />
        </>
      )}

      <MasterJobTablePopUp empState={empStatelist} getData={getData} />

      {showBranchCreationEditPopup && (
        <div className="fixed inset-0 z-50 bg-slate-950/50 backdrop-blur-sm flex justify-center items-start pt-10 overflow-auto">
          <div className="w-11/12 max-w-md max-h-[90vh] overflow-y-auto rounded-2xl border border-slate-200 bg-white p-6 shadow-xl flex flex-col">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h5 className="text-lg font-semibold text-slate-900">Branch</h5>
              {/* <img
          onClick={() => setShowBranchCreationEditPopup(prev => !prev)}
          src={ic_close_department}
          alt="Close"
          className="w-10 h-10 cursor-pointer object-contain"
        /> */}

              <FiX
                onClick={() => setShowBranchCreationEditPopup(false)}
                className="w-6 h-6 text-slate-600 hover:text-red-500 cursor-pointer"
              />
            </div>

            {/* Add New Branch Input */}
            <div className="flex items-center gap-3 mb-6">
              <input
                value={branchNameInInputBoxNew.branch_name}
                type="text"
                placeholder="Enter branch name"
                onChange={(e) =>
                  setBranchNameInInputBoxNew((prev) => ({
                    ...prev,
                    branch_name: e.target.value,
                  }))
                }
                className="flex-grow rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30"
              />
              <button
                onClick={() => newBranchAPI()}
                className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Add New Branch
              </button>
            </div>

            {/* Department List */}
            <div className="space-y-3">
              {departmentLisFromAPI &&
                departmentLisFromAPI.map((item) => (
                  <div
                    key={item.TranId}
                    className="rounded-xl border border-slate-200 bg-white"
                  >
                    {/* Branch name and edit icon */}
                    <div
                      onClick={() =>
                        setBranchNameInInputBoxEdit((prev) => ({
                          ...prev,
                          branch_name: item.Description,
                          transaction_id: item.TranId,
                        }))
                      }
                      className="flex justify-between items-center bg-slate-100 px-3 py-2 cursor-pointer hover:bg-slate-200 transition"
                    >
                      <span className="text-slate-900">{item.Description}</span>
                      {/* <img
                src={ic_pencil}
                alt="Edit"
                className="w-5 h-5"
              /> */}
                      {/* <img
                onClick={deleteDepartmentAPI}
                src={ic_pencil}
                alt="Edit"
                className="w-5 h-5"
              /> */}
                      <div className="flex justify-center gap-2 items-center">
                        <FiEdit2 className="text-blue-500 hover:text-blue-700 cursor-pointer w-5 h-5" />
                        <FiTrash2
                          onClick={deleteBranchAPI}
                          className="text-red-500 hover:text-red-700 cursor-pointer w-5 h-5"
                        />
                      </div>
                    </div>

                    {/* Edit input and buttons */}
                    {branchNameInInputBoxEdit.transaction_id
                      ?.trim()
                      .toLowerCase() === item.TranId?.trim().toLowerCase() && (
                      <div className="px-3 py-3 space-y-3">
                        <input
                          type="text"
                          placeholder="Enter branch name"
                          value={branchNameInInputBoxEdit.branch_name}
                          onChange={(e) =>
                            setBranchNameInInputBoxEdit((prev) => ({
                              ...prev,
                              branch_name: e.target.value,
                            }))
                          }
                          className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30"
                        />
                        <div className="flex gap-3">
                          <button
                            onClick={() =>
                              setBranchNameInInputBoxEdit(
                                initialBranchInActionEdit,
                              )
                            }
                            className="flex-1 rounded-xl border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-100"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => editBranchAPI()}
                            className="flex-1 rounded-xl bg-slate-900 px-3 py-2 text-sm font-medium text-white transition hover:bg-slate-800"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}

      {/* job title  */}

      {showJobTitleCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl max-h-[70vh] overflow-y-auto rounded-2xl border border-slate-200 bg-white p-6 shadow-xl scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-blue-600 flex items-center gap-2">
                <BusinessIcon className="text-blue-600" />
                JOB TITLE MANAGEMENT
              </h2>

              <button
                onClick={() => setShowJobTitleCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-slate-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            {/* Add New Job Title */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={jobTitleNameInInputBoxNew.jobTitle_name}
                type="text"
                placeholder="Enter new Job Title here..."
                className="w-full border border-slate-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition"
                onChange={(e) =>
                  setJobTitleNameInInputBoxNew((prev) => ({
                    ...prev,
                    jobTitle_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newJobTitleAPI}
                className="
          inline-flex items-center gap-2
          bg-blue-600
          text-white
          w-1/2
          px-2 py-1
          text-sm font-semibold
          rounded-xl
          shadow-sm
          hover:from-blue-700 hover:to-blue-600
          active:scale-95
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
        "
              >
                <Plus size={16} />
                Add Job Title
              </button>
            </div>

            {/* JobTitle List */}
            <div className="mt-6 space-y-3">
              {jobTitleListFromAPI?.map((item) => {
                const isEditing =
                  jobTitleNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-slate-200 rounded-xl px-2 py-1 hover:shadow-sm transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-slate-600">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setJobTitleNameInInputBoxEdit({
                            jobTitle_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-xl hover:bg-slate-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-slate-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={jobTitleNameInInputBoxEdit.jobTitle_name}
                          onChange={(e) =>
                            setJobTitleNameInInputBoxEdit((prev) => ({
                              ...prev,
                              jobTitle_name: e.target.value,
                            }))
                          }
                          className="w-full border border-slate-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setJobTitleNameInInputBoxEdit(
                                initialJobTitleInActionEdit,
                              )
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-xl border border-slate-300 text-slate-600 hover:bg-slate-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editJobTitleAPI}
                            className="flex items-center gap-1 bg-emerald-600 text-white px-3 py-2 rounded-xl hover:bg-emerald-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Department  */}

      {showDepartmentCreationEditPopup && (
        <div className="fixed inset-0 z-50 bg-slate-950/50 backdrop-blur-sm flex justify-center items-start pt-10 overflow-auto">
          <div className="w-11/12 max-w-md max-h-[90vh] overflow-y-auto rounded-2xl border border-slate-200 bg-white p-6 shadow-xl flex flex-col">
            <div className="flex justify-between items-center mb-4">
              <h5 className="text-lg font-semibold text-slate-900">
                Department
              </h5>
              {/* <img
          onClick={() => setShowDepartmentCreationEditPopup(false)}
          src={ic_close_department}
          alt="Close"
          className="w-10 h-10 cursor-pointer object-contain"
        /> */}
              <FiX
                onClick={() => setShowDepartmentCreationEditPopup(false)}
                className="w-6 h-6 text-slate-600 hover:text-red-500 cursor-pointer"
              />
            </div>

            {/* Add New Department */}
            <div className="flex items-center gap-3 mb-6">
              <input
                value={departmentNameInInputBoxNew.branch_name}
                type="text"
                placeholder="Enter department name"
                onChange={(e) =>
                  setDepartmentNameInInputBoxNew((prev) => ({
                    ...prev,
                    branch_name: e.target.value,
                  }))
                }
                className="flex-grow rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30"
              />
              <button
                onClick={newDepartmentAPI}
                className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Add New Department
              </button>
            </div>

            {/* Department List */}
            <div className="space-y-3">
              {deptLisFromAPI?.map((item) => (
                <div
                  key={item.TranId}
                  className="rounded-xl border border-slate-200 bg-white"
                >
                  <div
                    onClick={() =>
                      setDepartmentNameInInputBoxEdit({
                        branch_name: item.Description,
                        transaction_id: item.TranId,
                      })
                    }
                    className="flex justify-between items-center bg-slate-100 px-3 py-2 cursor-pointer hover:bg-slate-200 transition"
                  >
                    <span className="text-slate-900">{item.Description}</span>
                    <div className="flex gap-2">
                      <FiEdit2 className="text-blue-500 hover:text-blue-700 cursor-pointer w-5 h-5" />
                      <FiTrash2
                        onClick={() => deleteDepartmentAPI(item.TranId)}
                        className="text-red-500 hover:text-red-700 cursor-pointer w-5 h-5"
                      />
                    </div>
                  </div>

                  {departmentNameInInputBoxEdit.transaction_id ===
                    item.TranId && (
                    <div className="px-3 py-3 space-y-3">
                      <input
                        value={departmentNameInInputBoxEdit.branch_name}
                        onChange={(e) =>
                          setDepartmentNameInInputBoxEdit((prev) => ({
                            ...prev,
                            branch_name: e.target.value,
                          }))
                        }
                        className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30"
                      />
                      <div className="flex gap-3">
                        <button
                          onClick={() =>
                            setDepartmentNameInInputBoxEdit(
                              initialDepartmentInActionEdit,
                            )
                          }
                          className="flex-1 rounded-xl border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-100"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => editDepartmentAPI()}
                          className="flex-1 rounded-xl bg-slate-900 px-3 py-2 text-sm font-medium text-white transition hover:bg-slate-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {showShiftGroupCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl max-h-[70vh] overflow-y-auto rounded-2xl border border-slate-200 bg-white p-6 shadow-xl scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-blue-600 flex items-center gap-2">
                <BusinessIcon className="text-blue-600" />
                SHIFT GROUP MANAGEMENT
              </h2>

              <button
                onClick={() => setShowShiftGroupCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-slate-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            {/* Add New Division */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={shiftGroupNameInInputBoxNew.shiftGroup_name}
                type="text"
                placeholder="Enter new shift Group name here..."
                className="w-full border border-slate-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition"
                onChange={(e) =>
                  setShiftGroupNameInInputBoxNew((prev) => ({
                    ...prev,
                    shiftGroup_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newShiftGroupAPI}
                className="
          inline-flex items-center gap-2
          bg-blue-600
          text-white
          w-1/2
          px-2 py-1
          text-sm font-semibold
          rounded-xl
          shadow-sm
          hover:from-blue-700 hover:to-blue-600
          active:scale-95
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
        "
              >
                <Plus size={16} />
                Add Shift Group
              </button>
            </div>

            {/* Shift Group List */}
            <div className="mt-6 space-y-3">
              {shiftGroupListFromAPI?.map((item) => {
                const isEditing =
                  shiftGroupNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-slate-200 rounded-xl px-2 py-1 hover:shadow-sm transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-slate-600">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setShiftGroupNameInInputBoxEdit({
                            division_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-xl hover:bg-slate-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-slate-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={shiftGroupNameInInputBoxEdit.shiftGroup_name}
                          onChange={(e) =>
                            setShiftGroupNameInInputBoxEdit((prev) => ({
                              ...prev,
                              shiftGroup_name: e.target.value,
                            }))
                          }
                          className="w-full border border-slate-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setShiftGroupNameInInputBoxEdit(
                                initialShiftGroupInActionEdit,
                              )
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-xl border border-slate-300 text-slate-600 hover:bg-slate-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editDivisionAPI}
                            className="flex items-center gap-1 bg-emerald-600 text-white px-3 py-2 rounded-xl hover:bg-emerald-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {showDivisionCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl max-h-[70vh] overflow-y-auto rounded-2xl border border-slate-200 bg-white p-6 shadow-xl scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-blue-600 flex items-center gap-2">
                <BusinessIcon className="text-blue-600" />
                DIVISION MANAGEMENT
              </h2>

              <button
                onClick={() => setShowDivisionCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-slate-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            {/* Add New Division */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={divisionNameInInputBoxNew.division_name}
                type="text"
                placeholder="Enter new division name here..."
                className="w-full border border-slate-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition"
                onChange={(e) =>
                  setDivisionNameInInputBoxNew((prev) => ({
                    ...prev,
                    division_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newDivisionAPI}
                className="
    inline-flex items-center gap-2
    bg-blue-600
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-xl
    shadow-sm
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
              >
                <Plus size={16} />
                Add Division
              </button>
            </div>

            {/* Division List */}
            <div className="mt-6 space-y-3">
              {divisionListFromAPI?.map((item) => {
                const isEditing =
                  divisionNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-slate-200 rounded-xl px-2 py-1 hover:shadow-sm transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-slate-600">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setDivisionNameInInputBoxEdit({
                            division_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-xl hover:bg-slate-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-slate-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={divisionNameInInputBoxEdit.division_name}
                          onChange={(e) =>
                            setDivisionNameInInputBoxEdit((prev) => ({
                              ...prev,
                              division_name: e.target.value,
                            }))
                          }
                          className="w-full border border-slate-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setDivisionNameInInputBoxEdit(
                                initialDivisionInActionEdit,
                              )
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-xl border border-slate-300 text-slate-600 hover:bg-slate-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editDivisionAPI}
                            className="flex items-center gap-1 bg-emerald-600 text-white px-3 py-2 rounded-xl hover:bg-emerald-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Grade  */}

      {showGradeCreationEditPopup && (
        <div className="fixed inset-0 z-50 bg-slate-950/50 backdrop-blur-sm flex justify-center items-center pt-10 overflow-auto">
          <div className="w-11/12 max-w-md max-h-[90vh] overflow-y-auto rounded-2xl border border-slate-200 bg-white p-6 shadow-xl flex flex-col">
            <div className="flex justify-between items-center mb-4 border-b pb-3">
              {/* <h5 className="text-lg font-semibold text-slate-900">Grade</h5> */}
              <h2 className="text-lg font-semibold text-blue-600 flex items-center gap-2">
                <StarHalfIcon className="text-blue-600" />
                GRADE
              </h2>
              {/* <img
          onClick={() => setShowGradeCreationEditPopup(false)}
          src={ic_close_department}
          alt="Close"
          className="w-10 h-10 cursor-pointer object-contain"
        /> */}

              <FiX
                onClick={() => setShowGradeCreationEditPopup(false)}
                className="w-6 h-6 text-slate-600 hover:text-red-500 cursor-pointer"
              />
            </div>

            {/* Add New Grade */}
            <div className="flex items-center gap-3 mb-6">
              {/* <input
                value={gradeNameInInputBoxNew.branch_name}
                type="text"
                placeholder="Enter grade name"
                onChange={(e) =>
                  setGradeNameInInputBoxNew((prev) => ({
                    ...prev,
                    branch_name: e.target.value,
                  }))
                }
                className="flex-grow rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30"
              /> */}

              <input
                value={gradeNameInInputBoxNew.division_name}
                type="text"
                placeholder="Enter new grade name here..."
                className="w-full border border-slate-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition"
                onChange={(e) =>
                  setGradeNameInInputBoxNew((prev) => ({
                    ...prev,
                    branch_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newGradeAPI}
                className="
    inline-flex items-center gap-2
    bg-blue-600
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-xl
    shadow-sm
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
              >
                <Plus size={16} />
                Add Grade
              </button>
            </div>

            {/* Grade List */}
            <div className="space-y-3">
              {gradeListFromAPI?.map((item) => (
                <div
                  key={item.TranId}
                  className="rounded-xl border border-slate-200 bg-white"
                >
                  <div
                    onClick={() =>
                      setGradeNameInInputBoxEdit({
                        branch_name: item.Description,
                        transaction_id: item.TranId,
                      })
                    }
                    className="flex justify-between items-center bg-transparent px-3 py-2 cursor-pointer hover:bg-slate-200 transition"
                  >
                    <span className="text-slate-900">{item.Description}</span>
                    <div className="flex gap-2">
                      <FiEdit2 className="text-blue-500 hover:text-blue-700 cursor-pointer w-5 h-5" />
                      <FiTrash2
                        onClick={() => deleteGradeAPI(item.TranId)}
                        className="text-red-500 hover:text-red-700 cursor-pointer w-5 h-5"
                      />
                    </div>
                  </div>

                  {gradeNameInInputBoxEdit.transaction_id === item.TranId && (
                    <div className="px-3 py-3 space-y-3">
                      <input
                        value={gradeNameInInputBoxEdit.branch_name}
                        onChange={(e) =>
                          setGradeNameInInputBoxEdit((prev) => ({
                            ...prev,
                            branch_name: e.target.value,
                          }))
                        }
                        className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30"
                      />
                      <div className="flex gap-3">
                        <button
                          onClick={() =>
                            setGradeNameInInputBoxEdit(initialGradeInActionEdit)
                          }
                          className="flex-1 rounded-xl border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-100"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => editGradeAPI()}
                          className="flex-1 rounded-xl bg-slate-900 px-3 py-2 text-sm font-medium text-white transition hover:bg-slate-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditForm;
